import { Component, OnInit, OnDestroy, ElementRef, ViewChild } from '@angular/core'
import { Router } from '@angular/router'
import { NotBlankGenericFieldValidator } from '../../../../validations/not-blank-generic-field-validator'
import { DateTextFieldValidator } from '../../../../validations/date-text-field.validator'
import { ZipTextFieldValidator } from '../../../../validations/zip-text-field-validator'
import { DataEntryStep1 } from '../../../models/data-entry-step1'
import { ValidatedRadioButtonModel } from '../../../../validations/validated-radio-button-group.component'
import { EnrollmentGateway } from '../../../gateways/enrollment-gateway'
import { PortalGlobals } from '../../../../portalglobals'
import { EnrollmentViewModel } from '../../../models/enrollment-view-model'
import { ValidAgent } from '../../../models/valid-agent'
import { GoodStandingModel } from '../../../../common/models/good-standing-model'
import * as moment from 'moment'
import { DrugPlan } from '../../../models/drug-plan'
import { PlanList } from '../../../models/plan-list'
import { ValidatedSelectOptionModel } from '../../../../validations/validated-dropdown.component'
import { ValidatedSelectOptionModel as State } from '../../../../validations/validated-dropdown.component'
import { PhoneNumberInputMask } from '../../../../common/input-masks/phone-number.input-mask'
import { LengthTextFieldValidator } from '../../../../validations/length-text-field-validator'
import { AccountTypes } from '../../../models/payment-account'
import { SubmitEnrollmentDataResponse } from '../../../models/submit-enrollment-data-response'
import { NetworkStateGateway } from './../../../../common/gateways/network-state-gateway'
import { GetEnrollmentDataResponse } from '../../../models/get-enrollment-data-response'
import { EnrollmentCacheData } from '../../../models/EnrollmentCacheData'
import { stcobModel } from '../../../models/stcob-model'
import { isPoBox } from '../../../../utils/is-po-box'
import { RaceEthnicityComponent } from '../../common/race-ethnicity.component'
import { Title } from '@angular/platform-browser';
import { ViewportScroller } from '@angular/common'
import { accountNameInvalidValidator, accountNumberInvalidValidator, emailValidFieldValidator, lettersCommaAndSpaceOnlyAllowedFieldValidator, lettersNumbersAndspacesValidator, LettersonlyAllowedFieldValidator, lettersPeriodsApostrophesAndSpacesValidator, lettersPeriodsApostrophesSpacesAndHyphensValidator, lettersSpaceshyphensAndApostrophesValidator, onlyDigitsValidator, phoneValidFieldValidator, specialChracterNotAllowedFieldValidator } from '../../../../validations/alpha-numeric-field-validator'

@Component({
    selector: 'NEJEDataEntryStep2',
    templateUrl: 'data-entry-step2.html'
})
export class NEJEDataEntryStep2Component implements OnInit, OnDestroy {
    private _raceEthnicityComponent: RaceEthnicityComponent

    notBlankValidator = new NotBlankGenericFieldValidator()
    enrollmentCacheData: EnrollmentCacheData = {} as EnrollmentCacheData
    validatedDate = new DateTextFieldValidator()
    validateZip = new ZipTextFieldValidator();
    dataEntryStep1 = {} as DataEntryStep1
    isValidAgent: boolean
    isFormValid: boolean
    selFaxContactType: string
    //dateofReceiptInvalid: boolean
    //ContactTypeInvalid: boolean
    showMLPAP: boolean
    //  public optionrbConactType: ValidatedRadioButtonModel[] = []
    // optionrbEnrollmentMethod: ValidatedRadioButtonModel[] = []
    // optionrbScope: ValidatedRadioButtonModel[] = []
    selEnrollmentMethod: string
    ErrorMessages: any[]
    enrollment: EnrollmentViewModel = {} as EnrollmentViewModel
    agentUserName: string
    hasError: boolean
    langFormat: boolean
    EnrollmentMethodError: boolean
    // SOAError: boolean
    validAgentModel: ValidAgent
    // CUID: string
    AgentID: string = 'step2-agent-id'
    //AdminID: number
    errorMessage: any[]
    IsErrorMesssage: boolean = false
    public loading: boolean = false
    goodStandingValues: GoodStandingModel = {} as GoodStandingModel
    planList: PlanList[] = [] as PlanList[]
    drugPlanModel = {} as DrugPlan
    selPlan: string
    enrollmentViewModel: EnrollmentViewModel = new EnrollmentViewModel()
    public optionrbPlan: ValidatedRadioButtonModel[] = []
    genderOptions: ValidatedRadioButtonModel[] = [] as ValidatedRadioButtonModel[]
    titleOptions: ValidatedSelectOptionModel[] = [] as ValidatedSelectOptionModel[]
    titleOption: string = ''
    genderOption: string = ''
    IsSameAddress: boolean
    states: State[] = [] as State[]
    mailingstates: State[] = [] as State[]
    public emergencycontactOptions: ValidatedRadioButtonModel[] = []
    public rblSecondaryCoverage: ValidatedRadioButtonModel[] = []
    IsCovergInfoYes: boolean
    IsCovergInfotext: boolean
    phoneNumberInputMask = new PhoneNumberInputMask()
    lengthValidator = new LengthTextFieldValidator(10)
    periodSelected = ''
    reasonCode: string = ''
    stcobDetail: stcobModel
    dateField: boolean
    isAEPVisible: boolean
    public IsAutomatciSocial: boolean
    public IsAUTOMATIC_RAILROAD: boolean
    public IsElectronicFund: boolean
    public IsMonthly: boolean
    public IsRblLISYes: boolean
    public IsRblLISNo: boolean
    IsSelectPlan: boolean
    IsRbllongtermYes: boolean
    IsEmergencyYes: boolean
    visibleFrom2025: boolean
    visibleFrom2026: boolean
    hasIncompleteError: boolean
    getEnrollmentDataResponse: GetEnrollmentDataResponse = new GetEnrollmentDataResponse()
    isIndv: boolean
    isPOBox: boolean
    disabledstate = false
    paymentOptions: ValidatedRadioButtonModel[] = [] as ValidatedRadioButtonModel[]
    public rbllongTerm: ValidatedRadioButtonModel[] = []
    public rblEnroleeWorkStatus: ValidatedRadioButtonModel[] = []
    public rblSpouceWorkStatus: ValidatedRadioButtonModel[] = []
    public rblAccessibility: ValidatedRadioButtonModel[] = []
    //PaperlessOption: boolean
    Script2020: boolean = false
    Showfor2023: boolean = false
    formSubmitTimeout: any;
    linktoErrorControl: any = {}
    accountTypeOptions: ValidatedRadioButtonModel[] = Object.keys(AccountTypes).map((accountTypeKey) => {
        return { value: accountTypeKey, htmlLabel: AccountTypes[accountTypeKey] }
    })

    @ViewChild('focusableEleTop', { static: true }) focusableEleTop: ElementRef
    emailLabel: string
    baseTitle: string

    //eobOptionLabel: string
    LettersonlyAllowedFieldValidator= new LettersonlyAllowedFieldValidator();
    lettersCommaAndSpaceAllowedFieldValidator=new lettersCommaAndSpaceOnlyAllowedFieldValidator();
    emailFieldValiator= new emailValidFieldValidator();
    phoneValidFieldValidator= new phoneValidFieldValidator();
    specialChracterNotAllowedFieldValidator=new specialChracterNotAllowedFieldValidator();
    accountNumberInvalidValidator=new accountNumberInvalidValidator();
    accountNameInvalidValidator=new accountNameInvalidValidator();
    lettersSpaceshyphensAndApostrophesValidator=new lettersSpaceshyphensAndApostrophesValidator();
    lettersNumbersAndspacesValidator=new lettersNumbersAndspacesValidator();
    lettersPeriodsApostrophesAndSpacesValidator= new lettersPeriodsApostrophesAndSpacesValidator();
    onlyDigitsValidator=new onlyDigitsValidator();
    lettersPeriodsApostrophesSpacesAndHyphensValidator= new lettersPeriodsApostrophesSpacesAndHyphensValidator();
    constructor(
        private router: Router,
        private _enrollementGateway: EnrollmentGateway,
        private _stateGateway: NetworkStateGateway,
        public _global: PortalGlobals,
        private titleService: Title,
        private scroller: ViewportScroller
    ) {
        this.emergencycontactOptions.push({ value: 'Yes', htmlLabel: 'Yes' }, { value: 'No', htmlLabel: 'No' })
        this.rblSecondaryCoverage.push({ value: 'Yes', htmlLabel: 'Yes' }, { value: 'No', htmlLabel: 'No' })
        this.rbllongTerm.push({ value: 'Yes', htmlLabel: 'Yes' }, { value: 'No', htmlLabel: 'No' })
        this.rblEnroleeWorkStatus.push({ value: 'Yes', htmlLabel: 'Yes' }, { value: 'No', htmlLabel: 'No' })
        this.rblSpouceWorkStatus.push({ value: 'Yes', htmlLabel: 'Yes' }, { value: 'No', htmlLabel: 'No' })
        this.rblAccessibility.push(
            { value: '2', htmlLabel: 'Braille' },
            { value: '1', htmlLabel: 'Large Print' },
            { value: '4', htmlLabel: 'Audio CD' }
        )

        if (this._global.selectedPlanYear > this._global.Planyear2024) {
            this.rblAccessibility.push({ value: '8', htmlLabel: 'Data CD' })
        }
        this.errorMessage = []
        this.IsSameAddress = true
        this._raceEthnicityComponent = new RaceEthnicityComponent(this._enrollementGateway)
        //this.eobOptionLabel = 'Yes, I want to go paperless for all available and future documents'

        if (Number(this._global.selectedPlanYear) === this._global.Planyear2023) {
            this.Showfor2023 = true
        } else {
            this.Showfor2023 = false
        }
        if (this._global.selectedPlanYear > this._global.Planyear2024) {
            this.visibleFrom2025 = true
        }
        if (this._global.selectedPlanYear > this._global.Planyear2025) {
            this.visibleFrom2026 = true;
        }
    }

    //eobOptionChanged(option: boolean) {
    //    if (option) {
    //        this.emailLabel = 'Email Address (Required for Paperless)'
    //        this.enrollmentViewModel.EOB = '3'
    //    } else {
    //        this.emailLabel = 'Email Address (Optional)'
    //        this.enrollmentViewModel.EOB = 'N'
    //    }
    //}

    ngOnInit() {
        // Set unique title
        this.baseTitle = this.titleService.getTitle();
        this.titleService.setTitle(this.baseTitle + ' - Individual Enrollment')

        this.emailLabel = 'Email Address (Required for Paperless)'
        this.hasError = false
        this.isIndv = false
        this.enrollmentViewModel = this._enrollementGateway.getEnrollmentViewModel()
        this.enrollmentViewModel.ISBACK = false

        this.ErrorMessages = [] as any[]
        const insCo = this._global.currentUser.insuranceCompanyShortName.toLowerCase()

        if (this.enrollmentViewModel === null || this.enrollmentViewModel === undefined) {
            this.router.navigate(['/' + insCo + '/enrollment/neje/data-entry/Step1'])
        }

        if (
            this.enrollmentViewModel.POVERIND !== undefined &&
            this.enrollmentViewModel.POVERIND != null &&
            this.enrollmentViewModel.POVERIND != '' &&
            this.enrollmentViewModel.POVERIND === '1') {
            this.poBoxChecked(true)
        }
        else {
            this.poBoxChecked(false)
        }

        if (Number(this._global.selectedPlanYear) === this._global.CurrentYear) {
            this.Script2020 = true
        }
        //NEJE DES Decommision Start
        //Get the Paperless settings from config
        //this._enrollementGateway.getPaperlessSetting("NEJEDataEntryPaperlessSetting").subscribe(
        //    data => {
        //        this.PaperlessOption = data
        //        this.enrollmentViewModel.PaperlessSettings = data
        //        if (this.PaperlessOption) {
        //            if (this.enrollmentViewModel.EOB === undefined || this.enrollmentViewModel.EOB == null) {
        //                this.eobOptionChanged(false)
        //            } else {
        //                this.eobOptionChanged(this.enrollmentViewModel.EOB ==='3')
        //            }
        //        }
        //    })
        //NEJE DES Decommision End
        if (this.Showfor2023) {
            if (
                this.enrollmentViewModel.LANGFORMAT === null ||
                this.enrollmentViewModel.LANGFORMAT === undefined ||
                this.enrollmentViewModel.LANGFORMAT === 'false'
            ) {
                this.langFormat = false
            } else if (this.enrollmentViewModel.LANGFORMAT === 'true') {
                this.langFormat = true
            }
        }
        if (this.enrollmentViewModel.AGENTID === null || this.enrollmentViewModel.AGENTID === undefined || this.enrollmentViewModel.AGENTID === '') {
            if (sessionStorage.getItem('EnrollmentCache') != null) {
                this.enrollmentCacheData = JSON.parse(sessionStorage.getItem('EnrollmentCache')!)

                //this.getEnrollmentDataResponse = this._enrollementGateway.getEnrollmentDataByKey(this.EnrollmentKey)

                this.loading = true
                this._enrollementGateway.getEnrollmentDataByKey(this.enrollmentCacheData.EnrollmentKey).subscribe(
                    (getEnrollmentDataResponse: GetEnrollmentDataResponse) => {
                        this.enrollmentViewModel = this._enrollementGateway.getEnrollmentViewModelByKey(getEnrollmentDataResponse)
                        this.enrollmentViewModel.ENROLLKEY = this.enrollmentCacheData.EnrollmentKey
                        this.enrollmentViewModel.ADMINID = this.enrollmentCacheData.AdminID
                        this.enrollmentViewModel.AGENTORGID = this.enrollmentCacheData.AgentOrgID
                        this.enrollmentViewModel.AGENTNAME = this.enrollmentCacheData.AgentName
                        this.enrollmentViewModel.PLANTYPENAME = this.enrollmentCacheData.PLANTYPENAME
                        this.enrollmentViewModel.USERNAME = this.enrollmentCacheData.USERNAME
                        this.enrollmentViewModel.FORMNAME = this.enrollmentCacheData.FORMNAME
                        this.enrollmentViewModel.SEPREASONTEXT = this.enrollmentCacheData.SEPREASONTEXT

                        var User = localStorage.getItem('UserSessionContext')
                        this._global.currentUser = JSON.parse(User!)

                        this.agentUserName = this.enrollmentViewModel.AGENTNAME
                        // this.enrollmentViewModel.PaperlessSettings = this.enrollmentCacheData.PaperlessSettings

                        this.dataEntryStep1.AgentName = this.enrollmentViewModel.AGENTNAME
                        this.isValidAgent = true
                        this.setValue()
                        this.loading = false

                        this.sepdatechange(this.enrollmentViewModel.SEPEFFDT)
                    },
                    (err) => {
                        this.loading = false
                    }
                )
            } else {
                this.router.navigate(['/' + insCo + '/enrollment/neje/data-entry/Step1'])
            }
        } else {
            var User = localStorage.getItem('UserSessionContext')
            this._global.currentUser = JSON.parse(User!)

            this.agentUserName = this.enrollmentViewModel.AGENTNAME

            this.dataEntryStep1.AgentName = this.enrollmentViewModel.AGENTNAME
            this.isValidAgent = true
            this.setValue()
        }
    }

    ngOnDestroy(): void {
        this.titleService.setTitle(this.baseTitle)
    }

    setValue(): void {
        this.genderOptions = [
            { value: 'M', htmlLabel: 'Male' },
            { value: 'F', htmlLabel: 'Female' }
        ]
        this.titleOptions = [
            { value: 'MR', text: 'MR' },
            { value: 'MRS', text: 'MRS' },
            { value: 'DR', text: 'DR' },
            { value: 'MS', text: 'MS' }
        ]
        this.loadPlanList()
        this.paymentOptions = [
            {
                value: 'Direct Bill',
                htmlLabel: 'Receive a bill'
            },
            {
                value: 'Automatic Bank Draft Withdrawal',
                htmlLabel: 'Automatic Bank Draft Withdrawal from Checking or Savings Account'
            },
            {
                value: 'Deduction from Social Security Check',
                htmlLabel: 'Automatic deduction from your monthly Social Security benefit check OR'
            },
            {
                value: 'Deduction from Railroad Retirement Board',
                htmlLabel: 'Automatic deduction from your monthly Railroad Retirement Board benefit check'
            }
        ]
        this.paymentOptionChanged(this.enrollmentViewModel.PWO)
        if (this.enrollmentViewModel.ISSAMEADDRESS !== null && this.enrollmentViewModel.ISSAMEADDRESS !== undefined) {
            //this.clickOnSameAsBusinessAddress(this.enrollmentViewModel.ISSAMEADDRESS)
        }
        if (this.enrollmentViewModel.AGENTORGID !== null && this.enrollmentViewModel.AGENTORGID !== undefined) {
            this._enrollementGateway
                .GetAllParentStatesForOrg(this.enrollmentViewModel.AGENTORGID)
                .subscribe((states: ValidatedSelectOptionModel[]) => {
                    states.unshift({ value: 0, text: '-- Choose One --' })
                    //  this.mailingstates = states
                    this.states = states
                    if (
                        this.enrollmentViewModel.APPST === undefined ||
                        this.enrollmentViewModel.APPST === '' ||
                        this.enrollmentViewModel.APPST === '0' ||
                        this.enrollmentViewModel.APPST === null
                    ) {
                        this.enrollmentViewModel.APPST = '0'
                    } else {
                        this.disabledstate = true
                    }

                    //this.mailingstates.unshift({ value: 0, text: '-- Choose One --', })
                })
        }
        this._stateGateway.getAllStatesforMailing().subscribe((states: State[]) => {
            states.unshift({ value: 0, text: '-- Choose One --' })
            this.mailingstates = states
            if (
                this.enrollmentViewModel.MAILST === undefined ||
                this.enrollmentViewModel.MAILST === '' ||
                this.enrollmentViewModel.MAILST === '0' ||
                this.enrollmentViewModel.MAILST === null
            ) {
                this.enrollmentViewModel.MAILST = '0'
            }
        })
        let today = new Date()
        //if (this.enrollmentViewModel.APPDT === null || this.enrollmentViewModel.APPDT === undefined) {
        //    this.enrollmentViewModel.APPDT = today
        //}
        if (
            this.enrollmentViewModel.ELECTION !== '' &&
            this.enrollmentViewModel.ELECTION !== null &&
            this.enrollmentViewModel.ELECTION !== undefined
        ) {
            this.periodSelectdChanged(this.enrollmentViewModel.ELECTION)
        }
        if (this.enrollmentViewModel.OTHCVRG !== '' && this.enrollmentViewModel.OTHCVRG !== null && this.enrollmentViewModel.OTHCVRG !== undefined) {
            this.ShowCoverageInfo(this.enrollmentViewModel.OTHCVRG)
        }
        if (
            this.enrollmentViewModel.RBLLONGTERM !== '' &&
            this.enrollmentViewModel.RBLLONGTERM !== null &&
            this.enrollmentViewModel.RBLLONGTERM !== undefined
        ) {
            this.ShowrbllongtermOptions(this.enrollmentViewModel.RBLLONGTERM)
        }
        if (this.enrollmentViewModel.ISSINGLEGROUP !== null && this.enrollmentViewModel.ISSINGLEGROUP !== undefined) {
            if (this.enrollmentViewModel.ISSINGLEGROUP) {
                this.isIndv = true
            }
        }
        if (this.enrollmentViewModel.APPST !== '' && this.enrollmentViewModel.APPST !== null && this.enrollmentViewModel.APPST !== undefined) {
            this.SelectState(this.enrollmentViewModel.APPST)
        }
        if (this.enrollmentViewModel.EMERIND !== '' && this.enrollmentViewModel.EMERIND !== null && this.enrollmentViewModel.EMERIND !== undefined) {
            this.ShowrEmergencyContactOptions(this.enrollmentViewModel.EMERIND)
        }
        if (this.enrollmentViewModel.APPDT !== null && this.enrollmentViewModel.APPDT !== undefined) {
            this.enrollmentViewModel.OldAppDT = this.enrollmentViewModel.APPDT
        }
    }

    onContinue(): void {
        this.enrollmentViewModel.ISBACK = true
        this._enrollementGateway.setEnrollmentViewModel(this.enrollmentViewModel)
        const insCo = this._global.currentUser.insuranceCompanyShortName.toLowerCase()
        this.router.navigate(['/' + insCo + '/enrollment/neje/data-entry/Step1'])
    }

    SelectState(selectstate: string) {
        //if (selectstate !== '' && selectstate !== undefined && selectstate !== '0') {
        //    this.planstatename = selectstate
        //}
        this.enrollmentViewModel.APPST = selectstate
        //  if (this.states !== undefined && this.states !== null) {
        //  if (this.states.length > 0)
        //  this.planstatename = this.states.filter(x => x.value === selectstate)[0].text

        //   }
        this.disabledstate = true
    }

    CheckUpdateApplicationDateForAEP() {
        if (this.enrollmentViewModel.ELECTION !== undefined && this.enrollmentViewModel.ELECTION !== null) {
            if (this.enrollmentViewModel.ELECTION === 'OpenEnrollment' || this.enrollmentViewModel.ELECTION.toLowerCase() === 'a') {
                if (
                    this._global.selectedPlanYear !== undefined &&
                    this._global.selectedPlanYear !== 0 &&
                    this.enrollmentViewModel.APPDT !== undefined &&
                    this.enrollmentViewModel.APPDT !== null &&
                    this.enrollmentViewModel.DATEOFRECEIPT !== undefined &&
                    this.enrollmentViewModel.DATEOFRECEIPT !== null
                ) {
                    let planYr: string
                    let dateOfReceipt: Date
                    let contactType: string
                    let minAppDt: Date
                    let maxAppDt: Date
                    planYr = String(this._global.selectedPlanYear - 1)
                    dateOfReceipt = new Date(this.enrollmentViewModel.DATEOFRECEIPT)
                    minAppDt = new Date('10/01/' + planYr)
                    maxAppDt = new Date('10/15/' + planYr)
                    contactType = this.enrollmentViewModel.AGENTDEX

                    //During pre AEP time allow Annual enrollment flip date
                    if (
                        dateOfReceipt >= minAppDt &&
                        dateOfReceipt <= maxAppDt &&
                        this.enrollmentViewModel.APPDT >= minAppDt &&
                        this.enrollmentViewModel.APPDT <= maxAppDt &&
                        (contactType.toLowerCase() == 'fax' || contactType.toLowerCase() == 'mlpap')
                    ) {
                        this.enrollmentViewModel.APPDT = new Date('10/15/' + planYr)
                    }
                }
            }
        }
    }

    getSTCOBDetail(orgId: number, planshortName: string) {
        this._enrollementGateway.getStcobDetail(orgId, planshortName, this.enrollmentViewModel.APPST).subscribe(
            (response: stcobModel) => {
                if (response !== undefined && response !== null) {
                    this.stcobDetail = response

                    this.enrollmentViewModel.ISSTCOB = this.stcobDetail.OptOutFlag.toLowerCase() == 'true' ? true : false
                    this.enrollmentViewModel.CARRIER = this.stcobDetail.PrimaryCarrier
                    this.enrollmentViewModel.ACCOUNT = this.stcobDetail.PrimaryAccount
                    this.enrollmentViewModel.GROUP = this.stcobDetail.PrimaryGroup
                    this.enrollmentViewModel.CUID = this.stcobDetail.CUID
                }
            },
            (err) => {
            }
        )
    }

    formSubmit(): void {
        this.ErrorMessages = [] as any[]

        // SUBMISSIONTYPECODE='PROSPECT' Only for Step 1 & 2 & 3 for enrollment
        this.enrollmentViewModel.SUBMISSIONTYPECODE = 'PROSPECT'
        this.enrollmentViewModel.STEPCODE = '2'
        this.enrollmentViewModel.PLANYEAR = String(this._global.selectedPlanYear)
        this.enrollmentViewModel.LANG = 'English'

        if (this.enrollmentViewModel.LANGFORMAT === undefined) {
            this.enrollmentViewModel.LANGFORMAT = this.Showfor2023 ? 'false' : ''
        }

        if (this.enrollmentViewModel.PWO !== 'Automatic Bank Draft Withdrawal') {
            this.resetBankDeatils()
        }
        if (this.enrollmentViewModel.EMERIND !== null && this.enrollmentViewModel.EMERIND !== undefined) {
            if (this.enrollmentViewModel.EMERIND.toUpperCase() === 'NO') {
                this.resetEmergencyDeatils()
            }
        }
        if (this.enrollmentViewModel.COBEFFDT === undefined) {
            this.enrollmentViewModel.COBEFFDT = undefined
        }
        if (this.enrollmentViewModel.COBTERMDT === undefined) {
            this.enrollmentViewModel.COBTERMDT = undefined
        }
        if (this.enrollmentViewModel.OTHCVRG !== null && this.enrollmentViewModel.OTHCVRG !== undefined) {
            if (this.enrollmentViewModel.OTHCVRG.toUpperCase() === 'NO') {
                this.enrollmentViewModel.COBBIN = ''
                this.enrollmentViewModel.COBPCN = ''
                this.enrollmentViewModel.OTHCVRGNAME = ''
                this.enrollmentViewModel.OTHCVRGID = ''
                this.enrollmentViewModel.OTHCVRGGRP = ''
                this.enrollmentViewModel.COBTERMDT = undefined
                this.enrollmentViewModel.COBEFFDT = undefined
            }
        }
        if (this.enrollmentViewModel.RBLLONGTERM !== null && this.enrollmentViewModel.RBLLONGTERM !== undefined) {
            if (this.enrollmentViewModel.RBLLONGTERM.toUpperCase() === 'NO') {
                this.enrollmentViewModel.LTCFACILITY = ''
                this.enrollmentViewModel.LTCADD1 = ''
                this.enrollmentViewModel.LTCPHONE = ''
            }
        }
        if (this.enrollmentViewModel.ISSAMEADDRESS) {
            this.enrollmentViewModel.MAILADD1 = this.enrollmentViewModel.APPADD1
            this.enrollmentViewModel.MAILADD2 = this.enrollmentViewModel.APPADD2
            this.enrollmentViewModel.MAILCITY = this.enrollmentViewModel.APPCITY
            this.enrollmentViewModel.MAILST = this.enrollmentViewModel.APPST
            this.enrollmentViewModel.MAILZIP = this.enrollmentViewModel.APPZIP
        }
        this.enrollmentViewModel.Race = this._raceEthnicityComponent.submitRaceDynamic(this.enrollmentViewModel.Race)
        this.enrollmentViewModel.Ethnicity = this._raceEthnicityComponent.submitEthnicityDynamic(this.enrollmentViewModel.Ethnicity)

        this.enrollmentViewModel.displayEthnicity = this._raceEthnicityComponent.selectedEthnicityDynamicModel(
            this.enrollmentViewModel.selectedEthnicity
        )
        this.enrollmentViewModel.displayRace = this._raceEthnicityComponent.selectedRaceDynamicModel(this.enrollmentViewModel.selecteRace)
        const insCo = this._global.currentUser.insuranceCompanyShortName.toLowerCase()

        this.CheckUpdateApplicationDateForAEP()

        this._enrollementGateway.setEnrollmentViewModel(this.enrollmentViewModel)
        setTimeout(() => {


            if (!this.isFormInvalid()) {
                this.loading = true

                //  this.loading = false
                //  this.router.navigate(['enrollment/neje/data-entry/Step3'])

                let mailStateCode = this.enrollmentViewModel.MAILST
                let mailZip = this.enrollmentViewModel.MAILZIP
                if (this.enrollmentViewModel.SAMEADDRESS) {
                    mailStateCode = '0'
                    mailZip = '0'
                }
                this._enrollementGateway.validateZip(this.enrollmentViewModel.APPST, this.enrollmentViewModel.APPZIP, mailStateCode, mailZip).subscribe(
                    (model: string[]) => {
                        if (model !== undefined && model !== null && model.length !== 0) {
                            this.ErrorMessages = model
                            this.hasError = true
                            window.scrollTo({ top: 0, behavior: 'smooth' });
                            this.loading = false
                        } else {
                            if (this.enrollmentViewModel.ENROLLKEY !== undefined && this.enrollmentViewModel.ENROLLKEY !== '') {
                                console.log('EnrollmentKey: ' + this.enrollmentViewModel.ENROLLKEY)
                                // console.log("EOB: " + this.enrollmentViewModel.EOB)

                                this._enrollementGateway.UpdateEnrollmentData(this.enrollmentViewModel).subscribe(
                                    (model: SubmitEnrollmentDataResponse) => {
                                        let response = model
                                        if (response !== undefined) {
                                            if (response.Errors !== undefined && response.Errors.length > 0) {
                                                this.hasError = true

                                                for (let i = 0; i < response.Errors.length; i++) {
                                                    this.ErrorMessages.push(response.Errors[i].ErrorMessage)
                                                }
                                                window.scrollTo({ top: 0, behavior: 'smooth' });
                                            } else {
                                                this.enrollmentViewModel.ENROLLKEY = response.EnrollmentKey

                                                this.enrollmentCacheData.EnrollmentKey = response.EnrollmentKey
                                                this.enrollmentCacheData.AgentName = this.enrollmentViewModel.AGENTNAME
                                                this.enrollmentCacheData.AgentID = this.enrollmentViewModel.AGENTID
                                                this.enrollmentCacheData.AdminID = this.enrollmentViewModel.ADMINID
                                                this.enrollmentCacheData.AgentOrgID = this.enrollmentViewModel.AGENTORGID
                                                this.enrollmentCacheData.PLANTYPENAME = this.enrollmentViewModel.PLANTYPENAME
                                                this.enrollmentCacheData.USERNAME = this.enrollmentViewModel.USERNAME
                                                this.enrollmentCacheData.FORMNAME = this.enrollmentViewModel.FORMNAME
                                                this.enrollmentCacheData.SEPREASONTEXT = this.enrollmentViewModel.SEPREASONTEXT
                                                // this.enrollmentCacheData.PaperlessSettings = this.enrollmentViewModel.PaperlessSettings

                                                sessionStorage.setItem('EnrollmentCache', JSON.stringify(this.enrollmentCacheData))

                                                this._enrollementGateway.setEnrollmentViewModel(this.enrollmentViewModel)
                                                this.loading = false
                                                this.router.navigate(['/' + insCo + '/enrollment/neje/data-entry/Step3'])
                                            }
                                        } else {
                                            this.ErrorMessages.push('Error while submitting data, please try again.')
                                            this.hasError = true
                                            window.scrollTo({ top: 0, behavior: 'smooth' });
                                        }
                                        this.loading = false
                                    },
                                    (err) => {
                                        this.loading = false
                                    }
                                )
                            } else {
                                this._enrollementGateway.SubmitEnrollmentData(this.enrollmentViewModel).subscribe(
                                    (model: SubmitEnrollmentDataResponse) => {
                                        let response = model
                                        if (response !== undefined) {
                                            if (response.Errors !== undefined && response.Errors.length > 0) {
                                                this.hasError = true
                                                
                                                //this.router.navigate(['/' + insCo + '/enrollment/neje/data-entry/Step3'])
                                                
                                                for (let i = 0; i < response.Errors.length; i++) {
                                                    this.ErrorMessages.push(response.Errors[i].ErrorMessage)
                                                }
                                                this.hasError = true
                                                window.scrollTo({ top: 0, behavior: 'smooth' });
                                            } else {
                                                if (
                                                    response.EnrollmentKey !== undefined &&
                                                    response.EnrollmentKey !== '' &&
                                                    response.EnrollmentKey !== null
                                                ) {
                                                    this.enrollmentViewModel.ENROLLKEY = response.EnrollmentKey

                                                    //Cache below data to retrive it from  DB.
                                                    this.enrollmentCacheData.EnrollmentKey = response.EnrollmentKey
                                                    this.enrollmentCacheData.AgentName = this.enrollmentViewModel.AGENTNAME
                                                    this.enrollmentCacheData.AgentID = this.enrollmentViewModel.AGENTID
                                                    this.enrollmentCacheData.AdminID = this.enrollmentViewModel.ADMINID
                                                    this.enrollmentCacheData.AgentOrgID = this.enrollmentViewModel.AGENTORGID
                                                    this.enrollmentCacheData.PLANTYPENAME = this.enrollmentViewModel.PLANTYPENAME
                                                    // this.enrollmentCacheData.PaperlessSettings = this.enrollmentViewModel.PaperlessSettings

                                                    sessionStorage.setItem('EnrollmentCache', JSON.stringify(this.enrollmentCacheData))

                                                    this._enrollementGateway.setEnrollmentViewModel(this.enrollmentViewModel)
                                                    this.loading = false
                                                    this.router.navigate(['/' + insCo + '/enrollment/neje/data-entry/Step3'])
                                                } else {
                                                    this.ErrorMessages.push('Error while submitting data, please try again.')
                                                    this.hasError = true
                                                    window.scrollTo({ top: 0, behavior: 'smooth' });
                                                }
                                            }
                                        } else {
                                            this.ErrorMessages.push('Error while submitting data, please try again.')
                                            this.hasError = true
                                            window.scrollTo({ top: 0, behavior: 'smooth' });
                                        }
                                        this.loading = false
                                    },
                                    (err) => {
                                        this.loading = false
                                    }
                                )
                            }
                        }
                    },
                    (err) => {
                        this.loading = false
                    }
                )
            } else {
                window.scrollTo({ top: 0, behavior: 'smooth' });
            }
        }, 10);

    }

    validateFutureDate(recdate: string): Boolean | undefined {
        var currentDate = new Date()
        let receiptdate = moment(recdate).toDate()
        if (receiptdate > currentDate) {
            return false
        }
    }

    onKeyDown(event) {
        const ENTER_KEY = 13
        if (event.keyCode === ENTER_KEY) {
            this.formSubmitTimeout = setTimeout(() => {
                this.formSubmit()
            });

        }
    }

    onPlanChange(planType: string) {
        if (planType !== undefined && planType !== '' && planType !== null) {
            this.enrollmentViewModel.PLANTYPE = planType

            if (this.enrollmentViewModel !== undefined && this.enrollmentViewModel.PLANTYPE != '') {
                //TO get CUID based on PlanType and populate here
                this.getSTCOBDetail(this.enrollmentViewModel.AGENTORGID, this.enrollmentViewModel.PLANTYPE)
            }

            if (this.optionrbPlan !== undefined && this.optionrbPlan !== null) {
                if (this.optionrbPlan.length > 0)
                    this.enrollmentViewModel.PLANTYPENAME = this.optionrbPlan.filter((x) => x.value === planType)[0].htmlLabel
            }
        }
    }

    loadPlanList() {
        this.enrollmentViewModel = this._enrollementGateway.getEnrollmentViewModel()
        let planyear
        if (this.enrollmentViewModel.PLANYEAR !== undefined) planyear = this.enrollmentViewModel.PLANYEAR
        else planyear = this._global.selectedPlanYear

        this._enrollementGateway.getPlanList(parseInt(this._global.currentUser.orgId), planyear).subscribe((model: PlanList[]) => {
            this.planList = model
            this.getPlanList(this.planList)
        })
    }

    poBoxChecked(option: boolean) {
        if (option) {
            this.enrollmentViewModel.POVERIND = '1'
            this.isPOBox = true
        }
        else {
            this.enrollmentViewModel.POVERIND = '0'
            this.isPOBox = false
        }

    }

    private getPlanList(planLst: PlanList[]) {
        this.optionrbPlan = planLst.map(this.buildPlanOption.bind(this))
        this.optionrbPlan = this.optionrbPlan.reverse()
    }

    private buildPlanOption(plan: PlanList): ValidatedRadioButtonModel {
        return {
            value: plan.PlanTypeShortName,
            htmlLabel: plan.PlanTypeName
        }
    }

    clickOnSameAsBusinessAddress(val: boolean) {
        if (val) {
            this.IsSameAddress = false
            this.enrollmentViewModel.MAILADD1 = this.enrollmentViewModel.APPADD1
            this.enrollmentViewModel.MAILADD2 = this.enrollmentViewModel.APPADD2
            this.enrollmentViewModel.MAILCITY = this.enrollmentViewModel.APPCITY
            this.enrollmentViewModel.MAILST = this.enrollmentViewModel.APPST
            this.enrollmentViewModel.MAILZIP = this.enrollmentViewModel.APPZIP
        } else {
            this.IsSameAddress = true
            this.enrollmentViewModel.MAILADD1 = ''
            this.enrollmentViewModel.MAILADD2 = ''
            this.enrollmentViewModel.MAILCITY = ''
            this.enrollmentViewModel.MAILST = ''
            this.enrollmentViewModel.MAILZIP = ''
        }

        this.enrollmentViewModel.ISSAMEADDRESS = val
    }

    onBlur() {
    }

    onBack(): void {
        this.enrollmentViewModel.ISBACK = true
        this._enrollementGateway.setEnrollmentViewModel(this.enrollmentViewModel)
        const insCo = this._global.currentUser.insuranceCompanyShortName.toLowerCase()
        this.router.navigate(['/' + insCo + '/enrollment/neje/data-entry/Step1'])
    }

    appRecievedDateChange(event: any) {
        this.enrollmentViewModel.APPDT = event
        if (
            this.enrollmentViewModel.APPDT !== undefined &&
            this.enrollmentViewModel.APPDT !== null &&
            (this.enrollmentViewModel.EFFDT === undefined || this.enrollmentViewModel.EFFDT === null)
        ) {
            let currDate = event
            if (currDate.getMonth() == 11) {
                this.enrollmentViewModel.EFFDT = new Date(currDate.getFullYear() + 1, 0, 1)
            } else {
                this.enrollmentViewModel.EFFDT = new Date(currDate.getFullYear(), currDate.getMonth() + 1, 1)
            }

            //If Year of Effective Date is not same as that of selected plan Year, default effective date will be 01/01 of next year
            if (this._global.selectedPlanYear !== undefined && this._global.selectedPlanYear !== 0) {
                if (this.enrollmentViewModel.EFFDT.getFullYear() !== this._global.selectedPlanYear) {
                    if (this._global.selectedPlanYear > currDate.getFullYear())
                        this.enrollmentViewModel.EFFDT = new Date(currDate.getFullYear() + 1, 0, 1)
                }
            }
        }
    }

    periodSelectdChanged(period: string) {
        this.periodSelected = this.enrollmentViewModel.ELECTION = period
        let currDate = new Date()
        if (this.periodSelected === 'OpenEnrollment') {
            if (this.enrollmentViewModel.EFFDT != new Date(currDate.getFullYear() + 1, 0, 1)) {
                if (currDate.getMonth() > 3) this.enrollmentViewModel.EFFDT = new Date(currDate.getFullYear() + 1, 0, 1)
            }
            //  this.disableEffectiveDate = true
        }
    }

    reasonCodeChanged(SelReasonCode: any) {
        this.enrollmentViewModel.SEPREASONTEXT = SelReasonCode.text
        this.enrollmentViewModel.ELECTIONTYPEID = SelReasonCode.id
        this.enrollmentViewModel.SEPREASONCD = SelReasonCode.value
        this.reasonCode = this.enrollmentViewModel.ELECTIONTYPEID + '|' + this.enrollmentViewModel.SEPREASONCD
        this.reasonCode = SelReasonCode.id + '|' + SelReasonCode.value
    }

    hasDateField(datefield: boolean) {
        this.dateField = datefield
    }

    sepdatechange(option: Date | null) {
        this.enrollmentViewModel.SEPEFFDT = option
    }

    AEPVisible(event: any) {
        if (event) {
            this.isAEPVisible = true
        }
    }

    paymentOptionChanged(option: string) {
        // this.enrollment.PWO = option
        // this.onPaymentOptionChange.emit(option)
        if (option === 'Deduction from Social Security Check') {
            this.IsAutomatciSocial = true
            this.IsAUTOMATIC_RAILROAD = false
            this.IsElectronicFund = false
            this.IsMonthly = false
            this.IsSelectPlan = false
        }
        if (option === 'Deduction from Railroad Retirement Board') {
            this.IsAutomatciSocial = false
            this.IsAUTOMATIC_RAILROAD = true
            this.IsElectronicFund = false
            this.IsMonthly = false
            this.IsSelectPlan = false
        }
        if (option === 'Automatic Bank Draft Withdrawal') {
            this.IsAutomatciSocial = false
            this.IsAUTOMATIC_RAILROAD = false
            this.IsElectronicFund = true
            this.IsMonthly = false
            this.IsSelectPlan = false
        }
        if (option === 'Direct Bill') {
            this.IsAutomatciSocial = false
            this.IsAUTOMATIC_RAILROAD = false
            this.IsElectronicFund = false
            this.IsMonthly = true
            this.IsSelectPlan = false
        }
        this.enrollmentViewModel.PWO = option
    }

    resetEmergencyDeatils() {
        this.enrollmentViewModel.EMERNAME = ''
        this.enrollmentViewModel.EMERPHONE = ''
        this.enrollmentViewModel.EMERREL = ''
    }

    resetBankDeatils() {
        this.enrollmentViewModel.ACCHOLDERNAME = ''
        this.enrollmentViewModel.EFTTYPE = ''
        this.enrollmentViewModel.FININSTNAME = ''
        this.enrollmentViewModel.ROUTINGNB = ''
        this.enrollmentViewModel.ACCOUNTNB = ''

        //this.paymentAccount.holderName = ''
        //this.paymentAccount.institution = ''
        //this.paymentAccount.number = ''
        //this.paymentAccount.routingNumber = ''
        //this.paymentAccount.type = null
        //this.paymentAccount = {} as PaymentAccount
        //this.enrollment.paymentAccount = this.paymentAccount
    }

    ShowCoverageInfo(val: any) {
        if (val === 'Yes') {
            this.IsCovergInfoYes = true
            this.IsCovergInfotext = true
            //   this.showsubmit = true
        }
        if (val === 'No') {
            this.IsCovergInfoYes = false
            this.IsCovergInfotext = false
            //  this.showsubmit = true
        }
        this.enrollmentViewModel.OTHCVRG = val
    }

    ShowrbllongtermOptions(val: any) {
        if (val === 'Yes') {
            this.IsRbllongtermYes = true
        }
        if (val === 'No') {
            this.IsRbllongtermYes = false
        }
        this.enrollmentViewModel.RBLLONGTERM = val
    }

    ShowrEmergencyContactOptions(val: any) {
        if (val === 'Yes') {
            this.IsEmergencyYes = true
        }
        if (val === 'No') {
            this.IsEmergencyYes = false
        }
        this.enrollmentViewModel.EMERIND = val
    }

    isFormInvalid(): boolean {
        this.hasError = false
        this.initializeControlError();
        //let HICNregex = new RegExp('[1-9](?![SLOIBZ])[A-Z](?![SLOIBZ])[A-Z 0-9][0-9](?![SLOIBZ])[A-Z](?![SLOIBZ])[A-Z 0-9][0-9](?![SLOIBZ])[A-Z](?![SLOIBZ])[A-Z][0-9][0-9]')

        //let validHICN = HICNregex.test(this.enrollmentViewModel.HICN)
        //if (!validHICN) {
        //    this.ErrorMessages.push('Invalid Medicare Number Format')
        //    this.hasError = true
        //}
        if (this.enrollmentViewModel.APPFN === undefined || this.enrollmentViewModel.APPFN === '') {
            this.ErrorMessages.push('First Name is required')
            this.hasError = true
        }
        if (this.enrollmentViewModel.APPLN === undefined || this.enrollmentViewModel.APPLN === '') {
            this.ErrorMessages.push('Last Name is required')
            this.hasError = true
        }

        if (this.enrollmentViewModel.APPDOB === undefined || this.enrollmentViewModel.APPDOB === null) {
            this.ErrorMessages.push('Date of Birth is required')
            this.hasError = true
        } else if (!moment(this.enrollmentViewModel.APPDOB).isValid()) {
            this.ErrorMessages.push('Date of Birth must be MM/DD/YYYY');
            this.hasError = true;
        } else {
            let dob = moment(this.enrollmentViewModel.APPDOB, 'MM/DD/YYYY')

            if (dob.isSameOrBefore('12/31/1889')) {
                this.hasError = true
                this.ErrorMessages.push('Invalid Date of Birth.')
            } else {

                if (dob > moment()) {
                    this.ErrorMessages.push('Date of Birth cannot be in the future')
                    this.hasError = true
                }
            }
        }

        if (this.enrollmentViewModel.APPGEN === undefined || this.enrollmentViewModel.APPGEN === '') {
            this.ErrorMessages.push('Sex is required')
            this.hasError = true
        }

        if (this.enrollmentViewModel.APPADD1 === undefined || this.enrollmentViewModel.APPADD1 === '') {
            this.ErrorMessages.push('Permanent Street Address Line 1 is required')
            this.hasError = true
        }
        else if (Number(this._global.selectedPlanYear) <= Number(this._global.Planyear2025)) {
            if (isPoBox(this.enrollmentViewModel.APPADD1)) {
                this.ErrorMessages.push('Permanent Address cannot be a PO Box')
                this.hasError = true
            }
        }
        if (this.enrollmentViewModel.APPCITY === undefined || this.enrollmentViewModel.APPCITY === '') {
            this.ErrorMessages.push('City is required')
            this.hasError = true
        } else {
            let regexCityVal = /^[A-Za-z\s\-.]+$/

            let isCityValid = regexCityVal.test(this.enrollmentViewModel.APPCITY)
            if (!isCityValid) {
                this.hasError = true
                this.ErrorMessages.push('Please enter valid City')
            }
        }

        if (this.enrollmentViewModel.APPST === undefined || this.enrollmentViewModel.APPST === '' || this.enrollmentViewModel.APPST === '0') {
            this.ErrorMessages.push('State is required')
            this.hasError = true
        }
        if (this.enrollmentViewModel.APPZIP === undefined || this.enrollmentViewModel.APPZIP === '') {
            this.ErrorMessages.push('Zip is required')
            this.hasError = true
        }
        if (this.enrollmentViewModel.ELECTION !== undefined && this.enrollmentViewModel.ELECTION !== '') {
            if (
                this.enrollmentViewModel.ELECTION === 'OpenEnrollment' &&
                this.enrollmentViewModel.APPDT != undefined &&
                this.enrollmentViewModel.APPDT != null
            ) {
                let appdate = moment(this.enrollmentViewModel.APPDT, 'MM/DD/YYYY')

                if (this.enrollmentViewModel.SEPREASONTEXT === undefined || this.enrollmentViewModel.SEPREASONTEXT === '') {
                    if (appdate.isAfter('12/07/' + moment().format('YYYY'))) {
                        this.ErrorMessages.push('App date should be between 10/15 and 12/07 for Annual')
                        this.hasError = true
                    } else {
                        this.ErrorMessages.push('Enrollment Criteria is required')
                        this.hasError = true
                    }
                }
            } else {
                if (this.enrollmentViewModel.SEPREASONTEXT === undefined || this.enrollmentViewModel.SEPREASONTEXT === '') {
                    this.ErrorMessages.push('Enrollment Criteria is required')
                    this.hasError = true
                }
            }
            if (this.enrollmentViewModel.ELECTION === 'Special') {
                if (this.dateField === true) {
                    if (this.enrollmentViewModel.SEPEFFDT === undefined || this.enrollmentViewModel.SEPEFFDT === null) {
                        this.ErrorMessages.push('SEP date is required')
                        this.hasError = true
                    }
                }
            }
        }

        if (this.enrollmentViewModel.ELECTION === undefined || this.enrollmentViewModel.ELECTION === '') {
            this.ErrorMessages.push('Election Period is required')
            this.hasError = true
        }

        if (this.enrollmentViewModel.MAILADD1 === undefined || this.enrollmentViewModel.MAILADD1 === '') {
            this.ErrorMessages.push('Mailing Address is required')
            this.hasError = true
        }

        if (this.enrollmentViewModel.MAILCITY === undefined || this.enrollmentViewModel.MAILCITY === '') {
            this.ErrorMessages.push('Mailing City is required')
            this.hasError = true
        } else {
            let regexCityVal = /^[A-Za-z\s\-.]+$/

            let isCityValid = regexCityVal.test(this.enrollmentViewModel.MAILCITY)
            if (!isCityValid) {
                this.hasError = true
                this.ErrorMessages.push('Please enter valid Mailing City')
            }
        }
        if (this.enrollmentViewModel.MAILST === undefined || this.enrollmentViewModel.MAILST === '' || this.enrollmentViewModel.MAILST === '0') {
            this.ErrorMessages.push('Mailing State is required')
            this.hasError = true
        }
        if (this.enrollmentViewModel.MAILZIP === undefined || this.enrollmentViewModel.MAILZIP === '') {
            this.ErrorMessages.push('Mailing Zip is required')
            this.hasError = true
        }

        if (this.enrollmentViewModel.APPDT === undefined || this.enrollmentViewModel.APPDT === null) {
            this.ErrorMessages.push('Application Date is required')
            this.hasError = true
        }
        //if (this.enrollmentViewModel.PLANST === undefined || this.enrollmentViewModel.PLANST === null) {
        //    this.ErrorMessages.push('Plan State is required')
        //    this.hasError = true

        //}

        if (this.enrollmentViewModel.HICN === undefined || this.enrollmentViewModel.HICN === null || this.enrollmentViewModel.HICN === '') {
            this.ErrorMessages.push('Medicare Number is required')
            this.hasError = true
        } else if (this.enrollmentViewModel.HICN.indexOf('-') > -1) {
            this.ErrorMessages.push('Please enter Medicare Number without -')
            this.hasError = true
        }

        /*
        if (this.enrollmentViewModel.CURRENTGENDER == "4" && (this.enrollmentViewModel.CURRENTGENDEROTH == undefined
            || this.enrollmentViewModel.CURRENTGENDEROTH == '')) {
            this.ErrorMessages.push('Different Gender Identity Required')
            this.hasError = true

        }
        if (this.enrollmentViewModel.GENDERNPRONOUN == "4" && (this.enrollmentViewModel.GENDERNPRONOUNOTH == undefined
            || this.enrollmentViewModel.GENDERNPRONOUNOTH == '')) {
            this.ErrorMessages.push('Different Self-Identity is Required')
            this.hasError = true

        }
        */

        //if (this.enrollmentViewModel.LANG === undefined || this.enrollmentViewModel.LANG === null) {
        //    this.ErrorMessages.push('Preferred Language is required')
        //    this.hasError = true

        //}

        if (this.enrollmentViewModel.EFFDT === undefined || this.enrollmentViewModel.EFFDT === null) {
            this.ErrorMessages.push('Effective Date is required')
            this.hasError = true
        } else {
            if (this.enrollmentViewModel.EFFDT.getDate() != 1) {
                this.ErrorMessages.push('The Effective Date must fall on the first of the month.')
                this.hasError = true
            }
            if (this.enrollmentViewModel.EFFDT.getFullYear() != this._global.selectedPlanYear) {
                this.ErrorMessages.push('The Effective Date must be in the same year as the Plan Year')
                this.hasError = true
            }
            if (this.enrollmentViewModel.APPDT && this.enrollmentViewModel.EFFDT <= this.enrollmentViewModel.APPDT) {
                this.ErrorMessages.push('Application date must be prior to the effective date.')
                this.hasError = true
            }
            // var date = new Date()
            //if (this.enrollmentViewModel.EFFDT.getMonth() <= (date.getMonth() - 1) || this.enrollmentViewModel.EFFDT.getMonth() <= (date.getMonth() + 3)) {
            //    this.ErrorMessages.push('The Effective Date can be 1 month before the current month and 3 months after the current month.')
            //    this.hasError = true

            //}
        }

        if (this.enrollmentViewModel.PLANTYPE === undefined || this.enrollmentViewModel.PLANTYPE === '') {
            this.ErrorMessages.push('Desired Plan is required')
            this.hasError = true
        }
        if (this.enrollmentViewModel.PWO === undefined || this.enrollmentViewModel.PWO === null) {
            this.ErrorMessages.push('How would you like to pay for the monthly premium is required')
            this.hasError = true
        }
        if (this.enrollmentViewModel.OTHCVRG === undefined || this.enrollmentViewModel.OTHCVRG === '') {
            this.ErrorMessages.push('Secondary Coverage is required')
            this.hasError = true
        } else {
            if (this.enrollmentViewModel.OTHCVRG !== undefined && this.enrollmentViewModel.OTHCVRG.toString().toLowerCase() === 'yes') {
                if (this.enrollmentViewModel.OTHCVRGNAME === undefined || this.enrollmentViewModel.OTHCVRGNAME === '') {
                    this.ErrorMessages.push('Other Coverage Name is required')
                    this.hasError = true
                }
                if (
                    this.enrollmentViewModel.OTHCVRGNAME !== undefined &&
                    this.enrollmentViewModel.OTHCVRGNAME !== '' &&
                    this.enrollmentViewModel.OTHCVRGNAME !== null
                ) {
                    let checkONAme = this.enrollmentViewModel.OTHCVRGNAME,
                        regexONameVal = /^[A-Za-z\s\-\' ]+$/
                    let isONAMEValid = regexONameVal.test(checkONAme)
                    if (!isONAMEValid) {
                        this.hasError = true
                        this.ErrorMessages.push('Other Coverage Name is invalid')
                    }
                }
                if (
                    this.enrollmentViewModel.OTHCVRGID !== undefined &&
                    this.enrollmentViewModel.OTHCVRGID !== '' &&
                    this.enrollmentViewModel.OTHCVRGID !== null
                ) {
                    let checkOID = this.enrollmentViewModel.OTHCVRGID,
                        regexOID = new RegExp('^[a-zA-Z0-9 ]*$')
                    let isOIDValid = regexOID.test(checkOID)
                    if (!isOIDValid) {
                        this.hasError = true
                        this.ErrorMessages.push('Other Coverage ID is invalid')
                    }
                }
                if (
                    this.enrollmentViewModel.OTHCVRGGRP !== undefined &&
                    this.enrollmentViewModel.OTHCVRGGRP !== '' &&
                    this.enrollmentViewModel.OTHCVRGGRP !== null
                ) {
                    let checkOTHCVRGGRP = this.enrollmentViewModel.OTHCVRGGRP,
                        regexOTHCVRGGRP = new RegExp('^[a-zA-Z0-9 ]*$')
                    let isOGRPValid = regexOTHCVRGGRP.test(checkOTHCVRGGRP)
                    if (!isOGRPValid) {
                        this.hasError = true
                        this.ErrorMessages.push('Other Coverage Group is invalid')
                    }
                }
            }
        }

        //if (this.PaperlessOption) {
        //        if (this.enrollmentViewModel.EOB === '3') {

        //            if (this.enrollmentViewModel.APPEMAIL === undefined || this.enrollmentViewModel.APPEMAIL === '') {
        //                this.ErrorMessages.push('Email Address is required for Paperless Documents')
        //                this.hasError = true
        //            }
        //            else {

        //                let unicodeRange = '(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])'
        //                let checkOrgEmail = this.enrollmentViewModel.APPEMAIL.toLowerCase()

        //                let isOrgEmailValid = this.isValidEmail(checkOrgEmail)
        //                if (!isOrgEmailValid) {
        //                    this.hasError = true
        //                    this.ErrorMessages.push('Invalid Email address for Paperless Documents')
        //                }
        //            }
        //        }
        //        if (this.enrollmentViewModel.EOB === undefined || this.enrollmentViewModel.EOB.toString().toLowerCase() === 'n') {
        //            if (this.enrollmentViewModel.APPEMAIL !== undefined && this.enrollmentViewModel.APPEMAIL !== '') {
        //                let unicodeRange = '(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])'
        //                let checkOrgEmail = this.enrollmentViewModel.APPEMAIL.toLowerCase()

        //                let isOrgEmailValid = this.isValidEmail(checkOrgEmail)
        //                if (!isOrgEmailValid) {
        //                    this.hasError = true
        //                    this.ErrorMessages.push('Invalid Email address for Paperless Documents')
        //                }

        //            }
        //        }
        //}

        if (this.enrollmentViewModel.PWO === 'Automatic Bank Draft Withdrawal') {
            if (
                this.enrollmentViewModel.ACCHOLDERNAME === undefined ||
                this.enrollmentViewModel.ACCHOLDERNAME === '' ||
                this.enrollmentViewModel.ACCHOLDERNAME === null
            ) {
                this.ErrorMessages.push('Please enter valid Account Name')
                this.hasError = true
            }
            if (
                this.enrollmentViewModel.ACCHOLDERNAME !== undefined &&
                this.enrollmentViewModel.ACCHOLDERNAME !== '' &&
                this.enrollmentViewModel.ACCHOLDERNAME !== null
            ) {
                let checkACCHOLDERNAME = this.enrollmentViewModel.ACCHOLDERNAME,
                    regexACCHOLDERNAMEVal = new RegExp("^[a-zA-Z0-9 -. ']*$")
                let isACCHOLDERNAMEValid = regexACCHOLDERNAMEVal.test(checkACCHOLDERNAME)
                if (!isACCHOLDERNAMEValid) {
                    this.hasError = true
                    this.ErrorMessages.push('Account Name on Bank Account is invalid')
                }
            }
            if (this.enrollmentViewModel.EFTTYPE === undefined || this.enrollmentViewModel.EFTTYPE === '') {
                this.ErrorMessages.push('Please select Account type')
                this.hasError = true
            }
            if (
                this.enrollmentViewModel.FININSTNAME === undefined ||
                this.enrollmentViewModel.FININSTNAME === '' ||
                this.enrollmentViewModel.FININSTNAME === null
            ) {
                this.ErrorMessages.push('Please enter valid Financial Institution')
                this.hasError = true
            }
            if (
                this.enrollmentViewModel.FININSTNAME !== undefined &&
                this.enrollmentViewModel.FININSTNAME !== '' &&
                this.enrollmentViewModel.FININSTNAME !== null
            ) {
                let checkFININSTNAME = this.enrollmentViewModel.FININSTNAME,
                    regexFININSTNAME = new RegExp("^[a-zA-Z0-9 -. ']*$")
                let isFININSTNAMEValid = regexFININSTNAME.test(checkFININSTNAME)
                if (!isFININSTNAMEValid) {
                    this.hasError = true
                    this.ErrorMessages.push('Financial Institution on Bank Account is invalid')
                }
            }
            if (
                this.enrollmentViewModel.ROUTINGNB === undefined ||
                this.enrollmentViewModel.ROUTINGNB === '' ||
                this.enrollmentViewModel.ROUTINGNB == null
            ) {
                this.ErrorMessages.push('Please enter valid Routing Number')
                this.hasError = true
            }
            if (
                this.enrollmentViewModel.ROUTINGNB !== undefined &&
                this.enrollmentViewModel.ROUTINGNB !== '' &&
                this.enrollmentViewModel.ROUTINGNB !== null
            ) {
                let checkROUTINGNB = this.enrollmentViewModel.ROUTINGNB,
                    regexROUTINGNB = new RegExp('^[0-9]*$')
                let isROUTINGNBValid = regexROUTINGNB.test(checkROUTINGNB)
                if (!isROUTINGNBValid) {
                    this.hasError = true
                    this.ErrorMessages.push('Routing Number is invalid')
                }
            }
            if (
                this.enrollmentViewModel.ROUTINGNB !== undefined &&
                this.enrollmentViewModel.ROUTINGNB !== '' &&
                this.enrollmentViewModel.ROUTINGNB !== null
            ) {
                if (this.enrollmentViewModel.ROUTINGNB.length !== 9) {
                    this.hasError = true
                    this.ErrorMessages.push('Routing number must be 9 numbers')
                }
            }

            if (this.enrollmentViewModel.ACCOUNTNB === undefined || this.enrollmentViewModel.ACCOUNTNB === '') {
                this.ErrorMessages.push('Please enter valid Account Number')
                this.hasError = true
            }
            if (
                this.enrollmentViewModel.ACCOUNTNB !== undefined &&
                this.enrollmentViewModel.ACCOUNTNB !== '' &&
                this.enrollmentViewModel.ACCOUNTNB !== null
            ) {
                let checkACCOUNTNB = this.enrollmentViewModel.ACCOUNTNB,
                    regexACCOUNTNB = new RegExp('[0-9]{6}')
                let isACCOUNTNBValid = regexACCOUNTNB.test(checkACCOUNTNB)
                if (!isACCOUNTNBValid) {
                    this.hasError = true
                    this.ErrorMessages.push('Account Number is invalid')
                }
            }
        }
        if (
            this.enrollmentViewModel.RBLLONGTERM === undefined ||
            this.enrollmentViewModel.RBLLONGTERM === null ||
            this.enrollmentViewModel.RBLLONGTERM === ''
        ) {
            this.ErrorMessages.push('Long Term Care Facility is required')
            this.hasError = true
        }
        if (this.enrollmentViewModel.RBLLONGTERM === 'Yes') {
            if (this.enrollmentViewModel.LTCFACILITY === undefined || this.enrollmentViewModel.LTCFACILITY === '') {
                this.ErrorMessages.push('Long Term Care Name is required.')
                this.hasError = true
            }
        }

        if (this.enrollmentViewModel.EMERIND === undefined || this.enrollmentViewModel.EMERIND === null || this.enrollmentViewModel.EMERIND === '') {
            this.ErrorMessages.push('Emergency Contact is required')
            this.hasError = true
        }
        if (this.enrollmentViewModel.EMERIND === 'Yes') {
            if (this.enrollmentViewModel.EMERNAME === undefined || this.enrollmentViewModel.EMERNAME === '') {
                this.ErrorMessages.push('Emergency Contact Name is required.')
                this.hasError = true
            }
            if (this.enrollmentViewModel.EMERPHONE === undefined || this.enrollmentViewModel.EMERPHONE === '') {
                this.ErrorMessages.push('Emergency Phone is required.')
                this.hasError = true
            }
            if (this.enrollmentViewModel.EMERREL === undefined || this.enrollmentViewModel.EMERREL === '') {
                this.ErrorMessages.push('Emergency Relationship is required.')
                this.hasError = true
            }
        }

        if (this.enrollmentViewModel.APPFN !== undefined && this.enrollmentViewModel.APPFN !== '' && this.enrollmentViewModel.APPFN !== null) {
            let checkFName = this.enrollmentViewModel.APPFN,
                regexFNameVal = new RegExp("^[a-zA-Z.' ]*$")
            let isFnameValid = regexFNameVal.test(checkFName)
            if (!isFnameValid) {
                this.hasError = true
                this.ErrorMessages.push('First Name is invalid')
            }
        }

        if (this.enrollmentViewModel.APPLN !== undefined && this.enrollmentViewModel.APPLN !== '' && this.enrollmentViewModel.APPLN !== null) {
            let checkLName = this.enrollmentViewModel.APPLN,
                regexFNameVal = new RegExp("^[a-zA-Z.' -]*$")
            let isLnameValid = regexFNameVal.test(checkLName)
            if (!isLnameValid) {
                this.hasError = true
                this.ErrorMessages.push('Last Name is invalid')
            }
        }
        if (this.enrollmentViewModel.APPMI !== undefined && this.enrollmentViewModel.APPMI !== '' && this.enrollmentViewModel.APPMI !== null) {
            let checkMI = this.enrollmentViewModel.APPMI,
                regexMIVal = new RegExp('^[a-zA-Z ]*$')
            let isMiValid = regexMIVal.test(checkMI)
            if (!isMiValid) {
                this.hasError = true
                this.ErrorMessages.push('MI is invalid')
            }
        }
        if (this.enrollmentViewModel.SUFFIX !== undefined && this.enrollmentViewModel.SUFFIX !== '') {
            let checkSuffix = this.enrollmentViewModel.SUFFIX,
                regexSuffixVal = new RegExp('^[a-zA-Z. 0-9]*$')
            let isSuffixValid = regexSuffixVal.test(checkSuffix)
            if (!isSuffixValid) {
                this.hasError = true
                this.ErrorMessages.push('Suffix is invalid')
            }
        }
        if (this.enrollmentViewModel.APPZIP !== undefined && this.enrollmentViewModel.APPZIP !== '' && this.enrollmentViewModel.APPZIP !== null) {
            let checkZipCode = this.enrollmentViewModel.APPZIP,
                regexVal = new RegExp('[0-9]{5}')
            let isZipCodeValid = regexVal.test(checkZipCode)
            if (!isZipCodeValid) {
                this.hasError = true
                this.ErrorMessages.push('Zip must be a five digit number')
            }
        }
        if (this.enrollmentViewModel.MAILZIP !== undefined && this.enrollmentViewModel.MAILZIP !== '' && this.enrollmentViewModel.MAILZIP !== null) {
            let checkZipCode = this.enrollmentViewModel.MAILZIP,
                regexVal = new RegExp('[0-9]{5}')
            let isZipCodeValid = regexVal.test(checkZipCode)
            if (!isZipCodeValid) {
                this.hasError = true
                this.ErrorMessages.push('Mailing Zip must be a five digit number')
            }
        }

        if (
            this.enrollmentViewModel.APPPHONE !== undefined &&
            this.enrollmentViewModel.APPPHONE !== '' &&
            this.enrollmentViewModel.APPPHONE !== null
        ) {
            let checkOrgPhone = this.enrollmentViewModel.APPPHONE.replace(/-/g, '')
            if (/^\d{10}$/.test(checkOrgPhone)) {
            } else {
                if (!this.isValidNumber(checkOrgPhone)) {
                    this.ErrorMessages.push('Phone cannot contain letters or special characters.')
                    this.hasError = true
                } else {
                    this.ErrorMessages.push('Phone must be exactly 10 numbers.')
                    this.hasError = true
                }
            }
        }
        if (
            this.enrollmentViewModel.LTCFACILITY !== undefined &&
            this.enrollmentViewModel.LTCFACILITY !== '' &&
            this.enrollmentViewModel.LTCFACILITY !== null
        ) {
            let checkLName = this.enrollmentViewModel.LTCFACILITY,
                regexFNameVal = new RegExp("^[a-zA-Z.' -]*$")
            let isLnameValid = regexFNameVal.test(checkLName)
            if (!isLnameValid) {
                this.hasError = true
                this.ErrorMessages.push('Long Term Care Name is invalid')
            }
        }
        if (
            this.enrollmentViewModel.LTCPHONE !== undefined &&
            this.enrollmentViewModel.LTCPHONE !== '' &&
            this.enrollmentViewModel.LTCPHONE !== null
        ) {
            let checkLTCPhone = this.enrollmentViewModel.LTCPHONE.replace(/-/g, '')
            if (/^\d{10}$/.test(checkLTCPhone)) {
            } else {
                if (!this.isValidNumber(checkLTCPhone)) {
                    this.ErrorMessages.push('Long-Term care facility phone cannot contain letters or special characters.')
                    this.hasError = true
                } else {
                    this.ErrorMessages.push('Long-Term care facility Phone must be exactly 10 numbers.')
                    this.hasError = true
                }
            }
        }
        if (
            this.enrollmentViewModel.EMERNAME !== undefined &&
            this.enrollmentViewModel.EMERNAME !== '' &&
            this.enrollmentViewModel.EMERNAME !== null
        ) {
            let checkLName = this.enrollmentViewModel.EMERNAME,
                regexFNameVal = new RegExp("^[a-zA-Z.' -]*$")
            let isLnameValid = regexFNameVal.test(checkLName)
            if (!isLnameValid) {
                this.hasError = true
                this.ErrorMessages.push('Emergency Contact Name is invalid')
            }
        }
        if (
            this.enrollmentViewModel.EMERPHONE !== undefined &&
            this.enrollmentViewModel.EMERPHONE !== '' &&
            this.enrollmentViewModel.EMERPHONE !== null
        ) {
            let checkOrgPhone = this.enrollmentViewModel.EMERPHONE.replace(/-/g, '')
            if (/^\d{10}$/.test(checkOrgPhone)) {
            } else {
                if (!this.isValidNumber(checkOrgPhone)) {
                    this.ErrorMessages.push('Emergency Phone cannot contain letters or special characters.')
                    this.hasError = true
                } else {
                    this.ErrorMessages.push('Emergency Phone must be exactly 10 numbers.')
                    this.hasError = true
                }
            }
        }
        let dob = moment(this.enrollmentViewModel.APPDOB, 'MM/DD/YYYY', true)

        if (dob.isSameOrBefore('1889-12-31')) {
            this.hasError = false
            this.ErrorMessages.push('Invalid Date of Birth.')
        }
        return this.hasError
    }

    private isValidEmail(text: string): boolean {
        return /^([\w-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,}|[0-9]{1,3})(\]?)$/.test(text)
    }

    private isValidNumber(text: string): boolean {
        return /^\d*$/.test(text)
    }

    incompleteClick() {
        // do incomplete validations
        this.ErrorMessages = [] as any[]
        this.hasIncompleteError = false
        this.initializeControlError();
        if (this.enrollmentViewModel.PWO !== 'Automatic Bank Draft Withdrawal') {
            this.resetBankDeatils()
        }
        if (this.enrollmentViewModel.EMERIND !== null && this.enrollmentViewModel.EMERIND !== undefined) {
            if (this.enrollmentViewModel.EMERIND.toUpperCase() === 'NO') {
                this.resetEmergencyDeatils()
            }
        }
        if (this.enrollmentViewModel.LANGFORMAT === undefined) {
            this.enrollmentViewModel.LANGFORMAT = this.Showfor2023 ? 'false' : ''
        }
        if (this.enrollmentViewModel.COBEFFDT === undefined) {
            this.enrollmentViewModel.COBEFFDT = undefined
        }
        if (this.enrollmentViewModel.COBTERMDT === undefined) {
            this.enrollmentViewModel.COBTERMDT = undefined
        }
        if (this.enrollmentViewModel.OTHCVRG !== null && this.enrollmentViewModel.OTHCVRG !== undefined) {
            if (this.enrollmentViewModel.OTHCVRG.toUpperCase() === 'NO') {
                this.enrollmentViewModel.COBBIN = ''
                this.enrollmentViewModel.COBPCN = ''
                this.enrollmentViewModel.OTHCVRGNAME = ''
                this.enrollmentViewModel.OTHCVRGID = ''
                this.enrollmentViewModel.OTHCVRGGRP = ''
                this.enrollmentViewModel.COBTERMDT = undefined
                this.enrollmentViewModel.COBEFFDT = undefined
            }
        }
        if (this.enrollmentViewModel.RBLLONGTERM !== null && this.enrollmentViewModel.RBLLONGTERM !== undefined) {
            if (this.enrollmentViewModel.RBLLONGTERM.toUpperCase() === 'NO') {
                this.enrollmentViewModel.LTCFACILITY = ''
                this.enrollmentViewModel.LTCADD1 = ''
                this.enrollmentViewModel.LTCPHONE = ''
            }
        }
        if (this.enrollmentViewModel.ISSAMEADDRESS) {
            this.enrollmentViewModel.MAILADD1 = this.enrollmentViewModel.APPADD1
            this.enrollmentViewModel.MAILADD2 = this.enrollmentViewModel.APPADD2
            this.enrollmentViewModel.MAILCITY = this.enrollmentViewModel.APPCITY
            this.enrollmentViewModel.MAILST = this.enrollmentViewModel.APPST
            this.enrollmentViewModel.MAILZIP = this.enrollmentViewModel.APPZIP
        }
        this.enrollmentViewModel.Race = this._raceEthnicityComponent.submitRaceDynamic(this.enrollmentViewModel.Race)
        this.enrollmentViewModel.Ethnicity = this._raceEthnicityComponent.submitEthnicityDynamic(this.enrollmentViewModel.Ethnicity)
        if (!this.incompleteClickValidation()) {
            this.enrollmentViewModel.SUBMISSIONTYPECODE = 'INCOMPLETE'
            this.enrollmentViewModel.PLANYEAR = String(this._global.selectedPlanYear)
            this._enrollementGateway.setEnrollmentViewModel(this.enrollmentViewModel)
            const insCo = this._global.currentUser.insuranceCompanyShortName.toLowerCase()
            this.router.navigate(['/' + insCo + '/enrollment/neje/data-entry/Step3'])
        } else {
            this.hasError = true
            window.scrollTo({ top: 0, behavior: 'smooth' });
        }
    }

    incompleteClickValidation(): boolean {
        if (this.enrollmentViewModel.APPDT === undefined || this.enrollmentViewModel.APPDT === null) {
            this.ErrorMessages.push('Application Receipt Date is required')
            this.hasIncompleteError = true
        }
        if (this.enrollmentViewModel.EFFDT === undefined || this.enrollmentViewModel.EFFDT === null) {
            this.ErrorMessages.push('Effective Date is required')
            this.hasIncompleteError = true
        } else {
            if (this.enrollmentViewModel.EFFDT.getFullYear() != this._global.selectedPlanYear) {
                this.ErrorMessages.push('The Effective Date must be in the same year as the Plan Year')
                this.hasIncompleteError = true
            }

            if (this.enrollmentViewModel.EFFDT.getDate() != 1) {
                this.ErrorMessages.push('The Effective Date must fall on the first of the month.')
                this.hasIncompleteError = true
            }
            if (this.enrollment.APPDT && this.enrollmentViewModel.EFFDT <= this.enrollment.APPDT) {
                this.ErrorMessages.push('Application date must be prior to the effective date.')
                this.hasIncompleteError = true
            }
        }

        if (this.enrollmentViewModel.ELECTION === undefined || this.enrollmentViewModel.ELECTION === '') {
            this.ErrorMessages.push('Election Period is required')
            this.hasIncompleteError = true
        }
        if (this.enrollmentViewModel.ELECTION !== undefined && this.enrollmentViewModel.ELECTION !== '') {
            if (
                this.enrollmentViewModel.ELECTION === 'OpenEnrollment' &&
                this.enrollmentViewModel.APPDT != undefined &&
                this.enrollmentViewModel.APPDT != null
            ) {
                let appdate = moment(this.enrollmentViewModel.APPDT, 'MM/DD/YYYY')

                if (this.enrollmentViewModel.SEPREASONTEXT === undefined || this.enrollmentViewModel.SEPREASONTEXT === '') {
                    if (appdate.isAfter('12/07/' + moment().format('YYYY'))) {
                        this.ErrorMessages.push('App date should be between 10/15 and 12/07 for Annual')
                        this.hasIncompleteError = true
                    } else {
                        this.ErrorMessages.push('Enrollment Criteria is required')
                        this.hasIncompleteError = true
                    }
                }
            } else {
                if (this.enrollmentViewModel.SEPREASONTEXT === undefined || this.enrollmentViewModel.SEPREASONTEXT === '') {
                    this.ErrorMessages.push('Enrollment Criteria is required')
                    this.hasIncompleteError = true
                }
            }
            if (this.enrollmentViewModel.ELECTION === 'Special') {
                if (this.dateField === true) {
                    if (this.enrollmentViewModel.SEPEFFDT === undefined || this.enrollmentViewModel.SEPEFFDT === null) {
                        this.ErrorMessages.push('SEP date is required')
                        this.hasIncompleteError = true
                    }
                }
            }
        }

        //if (this.enrollmentViewModel.APPCITY !== undefined && this.enrollmentViewModel.APPCITY !== '') {
        //    let regexCityVal = /^[A-Za-z\s\-.]+$/
        if (this.enrollmentViewModel.APPCITY !== undefined && this.enrollmentViewModel.APPCITY !== '') {
            let regexCityVal = /^[A-Za-z\s\-.]+$/

            //    let isCityValid = regexCityVal.test(this.enrollmentViewModel.APPCITY)
            //    if (!isCityValid) {
            //        this.hasIncompleteError = true
            //        this.ErrorMessages.push('Please enter valid City')
            //    }
            //}
            let isCityValid = regexCityVal.test(this.enrollmentViewModel.APPCITY)
            if (!isCityValid) {
                this.hasIncompleteError = true
                this.ErrorMessages.push('Please enter valid City')
            }
        }

        if (this.enrollmentViewModel.MAILCITY !== undefined && this.enrollmentViewModel.MAILCITY !== '') {
            let regexCityVal = /^[A-Za-z\s\-.]+$/

            let isCityValid = regexCityVal.test(this.enrollmentViewModel.MAILCITY)
            if (!isCityValid) {
                this.hasIncompleteError = true
                this.ErrorMessages.push('Please enter valid Mailing City')
            }
        }

        if (this.enrollmentViewModel.APPDOB === undefined || this.enrollmentViewModel.APPDOB === null) {
            this.ErrorMessages.push('Date of Birth is required')
            this.hasIncompleteError = true
        } else {
            if (this.enrollmentViewModel.APPDOB.toString() !== '') {
                let dob = moment(this.enrollmentViewModel.APPDOB, 'MM/DD/YYYY')

                if (dob.isSameOrBefore('12/31/1889')) {
                    this.hasIncompleteError = true
                    this.ErrorMessages.push('Invalid Date of Birth.')
                } else {
                    //if (!isMMDDYYYY(this.enrollmentViewModel.APPDOB.toString())) {
                    //    this.ErrorMessages.push('Date of Birth does not contain a valid Date')
                    //    this.hasIncompleteError = true
                    //}
                    if (dob > moment()) {
                        this.ErrorMessages.push('Date of Birth cannot be in the future')
                        this.hasIncompleteError = true
                    }
                }
            }
        }

        if (this.enrollmentViewModel.EFFDT !== undefined && this.enrollmentViewModel.EFFDT !== null) {
            if (this.enrollmentViewModel.EFFDT.getDate() != 1) {
                this.ErrorMessages.push('The Effective Date must fall on the first of the month.')
                this.hasIncompleteError = true
            }
            if (this.enrollmentViewModel.APPDT && this.enrollmentViewModel.EFFDT <= this.enrollmentViewModel.APPDT) {
                this.ErrorMessages.push('Application date must be prior to the effective date.')
                this.hasIncompleteError = true
            }
        }

        if (this.enrollmentViewModel.PWO === 'Automatic Bank Draft Withdrawal') {
            if (
                this.enrollmentViewModel.ACCHOLDERNAME !== undefined &&
                this.enrollmentViewModel.ACCHOLDERNAME !== '' &&
                this.enrollmentViewModel.ACCHOLDERNAME !== null
            ) {
                let checkACCHOLDERNAME = this.enrollmentViewModel.ACCHOLDERNAME,
                    regexACCHOLDERNAMEVal = new RegExp("^[a-zA-Z0-9 -. ']*$")
                let isACCHOLDERNAMEValid = regexACCHOLDERNAMEVal.test(checkACCHOLDERNAME)
                if (!isACCHOLDERNAMEValid) {
                    this.hasIncompleteError = true
                    this.ErrorMessages.push('Account Name on Bank Account is invalid')
                }
            }

            if (
                this.enrollmentViewModel.FININSTNAME !== undefined &&
                this.enrollmentViewModel.FININSTNAME !== '' &&
                this.enrollmentViewModel.FININSTNAME !== null
            ) {
                let checkFININSTNAME = this.enrollmentViewModel.FININSTNAME,
                    regexFININSTNAME = new RegExp("^[a-zA-Z0-9 -. ']*$")
                let isFININSTNAMEValid = regexFININSTNAME.test(checkFININSTNAME)
                if (!isFININSTNAMEValid) {
                    this.hasIncompleteError = true
                    this.ErrorMessages.push('Financial Institution on Bank Account is invalid')
                }
            }

            if (
                this.enrollmentViewModel.ROUTINGNB !== undefined &&
                this.enrollmentViewModel.ROUTINGNB !== '' &&
                this.enrollmentViewModel.ROUTINGNB !== null
            ) {
                let checkRoutingNb = this.enrollmentViewModel.ROUTINGNB,
                    regexVal = new RegExp('[0-9]{9}')
                let isRoutingNbrValid = regexVal.test(checkRoutingNb)
                if (!isRoutingNbrValid) {
                    this.hasIncompleteError = true
                    this.ErrorMessages.push('Routing Number is invalid')
                }
            }
            if (
                this.enrollmentViewModel.ROUTINGNB !== undefined &&
                this.enrollmentViewModel.ROUTINGNB !== '' &&
                this.enrollmentViewModel.ROUTINGNB !== null
            ) {
                if (this.enrollmentViewModel.ROUTINGNB.length !== 9) {
                    this.hasIncompleteError = true
                    this.ErrorMessages.push('Routing number must be 9 numbers')
                }
            }

            if (
                this.enrollmentViewModel.ACCOUNTNB !== undefined &&
                this.enrollmentViewModel.ACCOUNTNB !== '' &&
                this.enrollmentViewModel.ACCOUNTNB !== null
            ) {
                let checkACCOUNTNB = this.enrollmentViewModel.ACCOUNTNB,
                    regexACCOUNTNB = new RegExp('[0-9]{6}')
                let isACCOUNTNBValid = regexACCOUNTNB.test(checkACCOUNTNB)
                if (!isACCOUNTNBValid) {
                    this.hasIncompleteError = true
                    this.ErrorMessages.push('Account Number is invalid')
                }
            }
        }

        if (this.enrollmentViewModel.OTHCVRG !== undefined && this.enrollmentViewModel.OTHCVRG !== '') {
            if (this.enrollmentViewModel.OTHCVRG !== undefined && this.enrollmentViewModel.OTHCVRG.toString().toLowerCase() === 'yes') {
                if (
                    this.enrollmentViewModel.OTHCVRGNAME !== undefined &&
                    this.enrollmentViewModel.OTHCVRGNAME !== '' &&
                    this.enrollmentViewModel.OTHCVRGNAME !== null
                ) {
                    let checkONAme = this.enrollmentViewModel.OTHCVRGNAME,
                        regexONameVal = /^[A-Za-z\s\-\' ]+$/
                    let isONAMEValid = regexONameVal.test(checkONAme)
                    if (!isONAMEValid) {
                        this.hasError = true
                        this.ErrorMessages.push('Other Coverage Name is invalid')
                    }
                }
                if (
                    this.enrollmentViewModel.OTHCVRGID !== undefined &&
                    this.enrollmentViewModel.OTHCVRGID !== '' &&
                    this.enrollmentViewModel.OTHCVRGID !== null
                ) {
                    let checkOID = this.enrollmentViewModel.OTHCVRGID,
                        regexOID = new RegExp('^[a-zA-Z0-9 ]*$')
                    let isOIDValid = regexOID.test(checkOID)
                    if (!isOIDValid) {
                        this.hasError = true
                        this.ErrorMessages.push('Other Coverage ID is invalid')
                    }
                }
                if (
                    this.enrollmentViewModel.OTHCVRGGRP !== undefined &&
                    this.enrollmentViewModel.OTHCVRGGRP !== '' &&
                    this.enrollmentViewModel.OTHCVRGGRP !== null
                ) {
                    let checkOTHCVRGGRP = this.enrollmentViewModel.OTHCVRGGRP,
                        regexOTHCVRGGRP = new RegExp('^[a-zA-Z0-9 ]*$')
                    let isOGRPValid = regexOTHCVRGGRP.test(checkOTHCVRGGRP)
                    if (!isOGRPValid) {
                        this.hasError = true
                        this.ErrorMessages.push('Other Coverage Group is invalid')
                    }
                }
            }
        }

        if (this.enrollmentViewModel.APPEMAIL !== undefined && this.enrollmentViewModel.APPEMAIL !== '') {
            let unicodeRange = '(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])'
            let checkOrgEmail = this.enrollmentViewModel.APPEMAIL.toLowerCase()

            let isOrgEmailValid = this.isValidEmail(checkOrgEmail)
            if (!isOrgEmailValid) {
                this.hasIncompleteError = true
                this.ErrorMessages.push('Invalid Email address for Electronic Explanation of Benefits')
            }
        }

        if (this.enrollmentViewModel.APPFN !== undefined && this.enrollmentViewModel.APPFN !== '' && this.enrollmentViewModel.APPFN !== null) {
            let checkFName = this.enrollmentViewModel.APPFN,
                regexFNameVal = new RegExp("^[a-zA-Z.' ]*$")
            let isFnameValid = regexFNameVal.test(checkFName)
            if (!isFnameValid) {
                this.hasIncompleteError = true
                this.ErrorMessages.push('First Name is invalid')
            }
        }

        if (this.enrollmentViewModel.APPLN !== undefined && this.enrollmentViewModel.APPLN !== '' && this.enrollmentViewModel.APPLN !== null) {
            let checkLName = this.enrollmentViewModel.APPLN,
                regexFNameVal = new RegExp("^[a-zA-Z.' -]*$")
            let isLnameValid = regexFNameVal.test(checkLName)
            if (!isLnameValid) {
                this.hasIncompleteError = true
                this.ErrorMessages.push('Last Name is invalid')
            }
        }
        if (this.enrollmentViewModel.APPMI !== undefined && this.enrollmentViewModel.APPMI !== '' && this.enrollmentViewModel.APPMI !== null) {
            let checkMI = this.enrollmentViewModel.APPMI,
                regexMIVal = new RegExp('^[a-zA-Z ]*$')
            let isMiValid = regexMIVal.test(checkMI)
            if (!isMiValid) {
                this.hasIncompleteError = true
                this.ErrorMessages.push('MI is invalid')
            }
        }
        if (this.enrollmentViewModel.SUFFIX !== undefined && this.enrollmentViewModel.SUFFIX !== '') {
            let checkSuffix = this.enrollmentViewModel.SUFFIX,
                regexSuffixVal = new RegExp('^[a-zA-Z. 0-9]*$')
            let isSuffixValid = regexSuffixVal.test(checkSuffix)
            if (!isSuffixValid) {
                this.hasError = true
                this.ErrorMessages.push('Suffix is invalid')
            }
        }
        if (this.enrollmentViewModel.HICN !== undefined && this.enrollmentViewModel.HICN !== '' && this.enrollmentViewModel.HICN !== null) {
            if (this.enrollmentViewModel.HICN.indexOf('-') > -1) {
                this.ErrorMessages.push('Please enter Medicare Number without -')
                this.hasError = true
            } else {
                let checkMedicareNum = this.enrollmentViewModel.HICN,
                    regexMedicareNum = new RegExp(
                        '^([1-9](?![SLOIBZ])[A-Z](?![SLOIBZ])[A-Z 0-9][0-9](?![SLOIBZ])[A-Z](?![SLOIBZ])[A-Z 0-9][0-9](?![SLOIBZ])[A-Z](?![SLOIBZ])[A-Z][0-9][0-9]){1,10}$'
                    )

                checkMedicareNum = checkMedicareNum.replace(/-/g, '')
                if (checkMedicareNum.length == 10) {
                    let medicareNumError = false
                    var bytes = new Uint8Array(checkMedicareNum.length)
                    for (var i = 0; i < checkMedicareNum.length; i++) {
                        var ascii = checkMedicareNum.charCodeAt(i)
                        bytes[i] = ascii
                    }

                    for (var i = 0; i < bytes.length - 1; i++) {
                        if (!(bytes[i] >= 48 && bytes[i] <= 57)) {
                            medicareNumError = true
                        }
                    }
                    var length = bytes.length - 1
                    if (!((bytes[length] >= 65 && bytes[length] <= 90) || (bytes[length] >= 97 && bytes[length] <= 122))) {
                        medicareNumError = true
                    }

                    if (medicareNumError) {
                        this.hasIncompleteError = true
                        this.ErrorMessages.push('Invalid Medicare Number')
                    }
                } else if (checkMedicareNum.length == 11) {
                    let isMediCareNumValid = regexMedicareNum.test(checkMedicareNum)
                    if (!isMediCareNumValid) {
                        this.hasIncompleteError = true
                        this.ErrorMessages.push('Invalid Medicare Number')
                    }
                } else {
                    this.hasIncompleteError = true
                    this.ErrorMessages.push('Invalid Medicare Number')
                }
            }
        }

        if (this.enrollmentViewModel.APPZIP !== undefined && this.enrollmentViewModel.APPZIP !== '' && this.enrollmentViewModel.APPZIP !== null) {
            let checkZipCode = this.enrollmentViewModel.APPZIP,
                regexVal = new RegExp('[0-9]{5}')
            let isZipCodeValid = regexVal.test(checkZipCode)
            if (!isZipCodeValid) {
                this.hasIncompleteError = true
                this.ErrorMessages.push('Zip is invalid')
            }
        }
        if (this.enrollmentViewModel.MAILZIP !== undefined && this.enrollmentViewModel.MAILZIP !== '' && this.enrollmentViewModel.MAILZIP !== null) {
            let checkZipCode = this.enrollmentViewModel.MAILZIP,
                regexVal = new RegExp('[0-9]{5}')
            let isZipCodeValid = regexVal.test(checkZipCode)
            if (!isZipCodeValid) {
                this.hasIncompleteError = true
                this.ErrorMessages.push('Mailing Zip is invalid')
            }
        }

        if (
            this.enrollmentViewModel.APPPHONE !== undefined &&
            this.enrollmentViewModel.APPPHONE !== '' &&
            this.enrollmentViewModel.APPPHONE !== null
        ) {
            let checkOrgPhone = this.enrollmentViewModel.APPPHONE.replace(/-/g, '')
            if (/^\d{10}$/.test(checkOrgPhone)) {
            } else {
                if (!this.isValidNumber(checkOrgPhone)) {
                    this.ErrorMessages.push('Phone cannot contain letters or special characters.')
                    this.hasIncompleteError = true
                } else {
                    this.ErrorMessages.push('Phone must be exactly 10 numbers.')
                    this.hasIncompleteError = true
                }
            }
        }
        if (
            this.enrollmentViewModel.LTCFACILITY !== undefined &&
            this.enrollmentViewModel.LTCFACILITY !== '' &&
            this.enrollmentViewModel.LTCFACILITY !== null
        ) {
            let checkLName = this.enrollmentViewModel.LTCFACILITY,
                regexFNameVal = new RegExp("^[a-zA-Z.' -]*$")
            let isLnameValid = regexFNameVal.test(checkLName)
            if (!isLnameValid) {
                this.hasError = true
                this.ErrorMessages.push('Long Term Care Name is invalid')
            }
        }
        if (
            this.enrollmentViewModel.LTCPHONE !== undefined &&
            this.enrollmentViewModel.LTCPHONE !== '' &&
            this.enrollmentViewModel.LTCPHONE !== null
        ) {
            let checkLTCPhone = this.enrollmentViewModel.LTCPHONE.replace(/-/g, '')
            if (/^\d{10}$/.test(checkLTCPhone)) {
            } else {
                if (!this.isValidNumber(checkLTCPhone)) {
                    this.ErrorMessages.push('Long-Term care facility phone cannot contain letters or special characters.')
                    this.hasIncompleteError = true
                } else {
                    this.ErrorMessages.push('Long-Term care facility Phone must be exactly 10 numbers.')
                    this.hasIncompleteError = true
                }
            }
        }
        if (
            this.enrollmentViewModel.EMERNAME !== undefined &&
            this.enrollmentViewModel.EMERNAME !== '' &&
            this.enrollmentViewModel.EMERNAME !== null
        ) {
            let checkLName = this.enrollmentViewModel.EMERNAME,
                regexFNameVal = new RegExp("^[a-zA-Z.' -]*$")
            let isLnameValid = regexFNameVal.test(checkLName)
            if (!isLnameValid) {
                this.hasError = true
                this.ErrorMessages.push('Emergency Contact Name is invalid')
            }
        }
        if (
            this.enrollmentViewModel.EMERPHONE !== undefined &&
            this.enrollmentViewModel.EMERPHONE !== '' &&
            this.enrollmentViewModel.EMERPHONE !== null
        ) {
            let checkOrgPhone = this.enrollmentViewModel.EMERPHONE.replace(/-/g, '')
            if (/^\d{10}$/.test(checkOrgPhone)) {
            } else {
                if (!this.isValidNumber(checkOrgPhone)) {
                    this.ErrorMessages.push('Emergency Phone cannot contain letters or special characters.')
                    this.hasError = true
                } else {
                    this.ErrorMessages.push('Emergency Phone must be exactly 10 numbers.')
                    this.hasError = true
                }
            }
        }
        //let dob = moment(this.enrollmentViewModel.APPDOB, 'MM/DD/YYYY', true)

        //if (dob.isSameOrBefore('1889-12-31')) {
        //    this.hasIncompleteError = false
        //    this.ErrorMessages.push('Invalid Date of Birth.')
        //}
        return this.hasIncompleteError
    }

    medicareNumberValueChange(event: any) {
        this.enrollmentViewModel.HICN = event.toUpperCase()
    }

    HICNBlur() {
        if (this.enrollmentViewModel.HICN !== undefined && this.enrollmentViewModel.HICN.indexOf('-') >= 0) {
            let re = /\-/gi
            let updatedHICN = this.enrollmentViewModel.HICN.replace(re, '')
            this.enrollmentViewModel.HICN = updatedHICN.toUpperCase()
        }
    }

    onAppdatechange(event: any) {
        if (this.enrollmentViewModel.APPDT == null) {
            this.enrollmentViewModel.OldAppDT = new Date('01/01/1900')
        } else {
            this.enrollmentViewModel.OldAppDT = this.enrollmentViewModel.APPDT
        }
        this.enrollmentViewModel.APPDT = event
    }

    onLangFormatchange(value: any) {
        if (value) {
            this.enrollmentViewModel.LANGFORMAT = 'true'
            this.langFormat = true
        } else {
            this.enrollmentViewModel.LANGFORMAT = 'false'
            this.langFormat = false
        }
    }

    socialSecurityLinkOnClick() {
        clearTimeout(this.formSubmitTimeout); // Don't submit form for help link.
    }

initializeControlError(){
    this.linktoErrorControl = {
        isAPPFNError: false,
        isAPPLNrror: false,
        isAAPPMIrror: false,
        isPLANTYPError: false,
        isAPPDTError:false,
        isEFFDTError:false,
        isDOBError:false,
        isSexError:false,
        isAPPPHONEError:false,
        isAPPADD1rror:false,
        isAPPCITYrror:false,
        isAPPSTrror:false,
        isMAILADD1Error:false,
        isMAILCITYrror:false,
        isMAILSTrror:false,
        isMAILZIPrror:false,
        isEMERINDrror:false,
        isEMERNAMError:false,
        isEMERPHONError:false,
        isEMERRELError:false,
        isEEMERRELError:false,
        isAPPEMAILrror:false,
        isAHICNError:false,
        isreasonCodeError:false,
        isPWOError:false,         
        isROUTINGNBError:false,
        isACCOUNTNBError:false,
        istOTHCVRGError:false,
        isOTHCVRGIDrror:false,
        isOTHCVRGNAMError:false,
        isOTHCVRGGRPError:false,
        isRBLLONGTERMError:false,
        isZipERMError:false,
        isFININSTNAMEError:false,
        isEFTTYPEError:false,
        isACCHOLDERNAMEError:false
    }
}
    goToControl(text: string) {
       this.initializeControlError();
        if (text.includes('First Name')) {
            this.linktoErrorControl.isAPPFNError = true;
            this.scroller.scrollToAnchor("TxtAPPFN");
            // optionally focus after scrolling:
            const element = document.getElementById("TxtAPPFN");
            if(element){
                (element as HTMLElement).focus();
            }

        }
        if (text.includes('Last Name')) {
            this.linktoErrorControl.isAPPLNrror = true;
            this.scroller.scrollToAnchor("TxtAPPLN");
            // optionally focus after scrolling:
            const element = document.getElementById("TxtAPPLN");
            if(element){
                (element as HTMLElement).focus();
            }


        }
        if (text.includes('MI is invalid')) {
            this.linktoErrorControl.isAAPPMIrror = true;
            this.scroller.scrollToAnchor("TxtAPPMI");
            // optionally focus after scrolling:
            const element = document.getElementById("TxtAPPMI");
            if(element){
                (element as HTMLElement).focus();
            }

        }
        if (text.includes('Desired Plan is required')) {
            this.linktoErrorControl.isPLANTYPError = true;
            this.scroller.scrollToAnchor("TextPLANTYPE");
            // optionally focus after scrolling:
            const element = document.getElementById("TextPLANTYPE");
            if(element){
                (element as HTMLElement).focus();
            }        

        }
        if (text.includes('Application Date') || text.includes('Application Receipt Date is required') ) {
            this.linktoErrorControl.isAPPDTError = true;
            this.scroller.scrollToAnchor("TXTAPPDT");
            // optionally focus after scrolling:
            const element = document.getElementById("TXTAPPDT");
            if(element){
                (element as HTMLElement).focus();
            }        

        }
        if (text.includes('Financial Institution') ) {
            this.linktoErrorControl.isFININSTNAMEError = true;
            this.scroller.scrollToAnchor("txtFININSTNAME");
            // optionally focus after scrolling:
            const element = document.getElementById("txtFININSTNAME");
            if(element){
                (element as HTMLElement).focus();
            }        

        }
        if (text.includes('Effective Date')) {
            this.linktoErrorControl.isEFFDTError = true;
            this.scroller.scrollToAnchor("txtEFFDT");
            // optionally focus after scrolling:
            const element = document.getElementById("txtEFFDT");
            if(element){
                (element as HTMLElement).focus();
            }        

        }
        if (text.includes('Date of Birth')) {
            this.linktoErrorControl.isDOBError = true;
            this.scroller.scrollToAnchor("txtAPPDOB");
            // optionally focus after scrolling:
            const element = document.getElementById("txtAPPDOB");
            if(element){
                (element as HTMLElement).focus();
            }        

        }
        if (text.includes('Sex is required')) {
            this.linktoErrorControl.isSexError = true;
            this.scroller.scrollToAnchor("TxtAPPGEN");
            // optionally focus after scrolling:
            const element = document.getElementById("TxtAPPGEN");
            if(element){
                (element as HTMLElement).focus();
            }        

        }
        if (text.includes('Phone cannot contain letters or special characters.')||text.includes('Phone must be exactly 10 numbers.')) {
            this.linktoErrorControl.isAPPPHONEError = true;
            this.scroller.scrollToAnchor("txtAPPPHONE");
            // optionally focus after scrolling:
            const element = document.getElementById("txtAPPPHONE");
            if(element){
                (element as HTMLElement).focus();
            }        

        }
        if (text.includes('Permanent Street Address Line 1 is required')||text.includes('Permanent Address cannot be a PO Box')) {
            this.linktoErrorControl.isAPPADD1rror = true;
            this.scroller.scrollToAnchor("TxtAPPADD1");
            // optionally focus after scrolling:
            const element = document.getElementById("TxtAPPADD1");
            if(element){
                (element as HTMLElement).focus();
            }        

        }
        if (text.includes('City is required')||text.includes('Please enter valid City')) {
            this.linktoErrorControl.isAPPCITYrror = true;
            this.scroller.scrollToAnchor("txtAPPCITY");
            // optionally focus after scrolling:
            const element = document.getElementById("txtAPPCITY");
            if(element){
                (element as HTMLElement).focus();
            }        

        }
        if (text.includes('State is required')) {
            this.linktoErrorControl.isAPPSTrror = true;
            this.scroller.scrollToAnchor("txtAPPST");
            // optionally focus after scrolling:
            const element = document.getElementById("txtAPPST");
            if(element){
                (element as HTMLElement).focus();
            }        

        }
        if (text.includes('Mailing Address is required')) {
            this.linktoErrorControl.isMAILADD1Error = true;
            this.scroller.scrollToAnchor("txtMAILADD1");
            // optionally focus after scrolling:
            const element = document.getElementById("txtMAILADD1");
            if(element){
                (element as HTMLElement).focus();
            }        

        }
        if (text.includes('Mailing City is required')) {
            this.linktoErrorControl.isMAILCITYrror = true;
            this.scroller.scrollToAnchor("txtMAILCITY");
            // optionally focus after scrolling:
            const element = document.getElementById("txtMAILCITY");
            if(element){
                (element as HTMLElement).focus();
            }        

        }
        if (text.includes('Mailing State is required')) {
            this.linktoErrorControl.isMAILSTrror = true;
            this.scroller.scrollToAnchor("txtMAILST");
            // optionally focus after scrolling:
            const element = document.getElementById("txtMAILST");
            if(element){
                (element as HTMLElement).focus();
            }        

        }
        if (text.includes('Mailing Zip is required')) {
            this.linktoErrorControl.isMAILZIPrror = true;
            this.scroller.scrollToAnchor("txtMAILZIP");
            // optionally focus after scrolling:
            const element = document.getElementById("txtMAILZIP");
            if(element){
                (element as HTMLElement).focus();
            }        

        }
        if (text.includes('Emergency Contact is required')) {
            this.linktoErrorControl.isEMERINDrror = true;
            this.scroller.scrollToAnchor("txtEMERIND");
            // optionally focus after scrolling:
            const element = document.getElementById("txtEMERIND");
            if(element){
                (element as HTMLElement).focus();
            }        

        }
        if (text.includes('Emergency Contact Name is required.')) {
            this.linktoErrorControl.isEMERNAMError = true;
            this.scroller.scrollToAnchor("txtEMERNAME");
            // optionally focus after scrolling:
            const element = document.getElementById("txtEMERNAME");
            if(element){
                (element as HTMLElement).focus();
            }        

        }
        if (text.includes('Emergency Phone')) {
            this.linktoErrorControl.isEMERPHONError = true;
            this.scroller.scrollToAnchor("txtEMERPHONE");
            // optionally focus after scrolling:
            const element = document.getElementById("txtEMERPHONE");
            if(element){
                (element as HTMLElement).focus();
            }        

        }
        if (text.includes('Emergency Relationship is required.')) {
            this.linktoErrorControl.isEEMERRELError = true;
            this.scroller.scrollToAnchor("txtEMERREL");
            // optionally focus after scrolling:
            const element = document.getElementById("txtEMERREL");
            if(element){
                (element as HTMLElement).focus();
            }        

        }
        if (text.includes('Invalid Email address for Electronic Explanation of Benefits')) {
            this.linktoErrorControl.isAPPEMAILrror = true;
            this.scroller.scrollToAnchor("txtAPPEMAIL");
            // optionally focus after scrolling:
            const element = document.getElementById("txtAPPEMAIL");
            if(element){
                (element as HTMLElement).focus();
            }        

        }
        if (text.includes('Medicare Number')) {
            this.linktoErrorControl.isAHICNError = true;
            this.scroller.scrollToAnchor("txtHICN");
            // optionally focus after scrolling:
            const element = document.getElementById("txtHICN");
            if(element){
                (element as HTMLElement).focus();
            }        

        }
        if (text.includes('Election Period is required')) {
            this.linktoErrorControl.isreasonCodeError = true;
            this.scroller.scrollToAnchor("txtreasonCode");
            // optionally focus after scrolling:
            const element = document.getElementById("txtreasonCode");
            if(element){
                (element as HTMLElement).focus();
            }        

        }
        if (text.includes('How would you like to pay for the monthly premium is required')) {
            this.linktoErrorControl.isPWOError = true;
            this.scroller.scrollToAnchor("txtPWO");
            // optionally focus after scrolling:
            const element = document.getElementById("txtPWO");
            if(element){
                (element as HTMLElement).focus();
            }        

        }
        if (text.includes('Routing Number')) {
            this.linktoErrorControl.isROUTINGNBError = true;
            this.scroller.scrollToAnchor("txtROUTINGNB");
            // optionally focus after scrolling:
            const element = document.getElementById("txtROUTINGNB");
            if(element){
                (element as HTMLElement).focus();
            }        

        }
        if (text.includes('Account Number')) {
            this.linktoErrorControl.isACCOUNTNBError = true;
            this.scroller.scrollToAnchor("txtACCOUNTNB");
            // optionally focus after scrolling:
            const element = document.getElementById("txtACCOUNTNB");
            if(element){
                (element as HTMLElement).focus();
            }        

        }
        if (text.includes('Secondary Coverage is required')) {
            this.linktoErrorControl.istOTHCVRGError = true;
            this.scroller.scrollToAnchor("txtOTHCVRG");
            // optionally focus after scrolling:
            const element = document.getElementById("txtOTHCVRG");
            if(element){
                (element as HTMLElement).focus();
            }        

        }
        if (text.includes('Other Coverage ID is invalid')) {
            this.linktoErrorControl.isOTHCVRGIDrror = true;
            this.scroller.scrollToAnchor("txtOTHCVRGID");
            // optionally focus after scrolling:
            const element = document.getElementById("txtOTHCVRGID");
            if(element){
                (element as HTMLElement).focus();
            }        

        }
        if (text.includes('Other Coverage Name is invalid')) {
            this.linktoErrorControl.isOTHCVRGNAMError = true;
            this.scroller.scrollToAnchor("txtOTHCVRGNAME");
            // optionally focus after scrolling:
            const element = document.getElementById("txtOTHCVRGNAME");
            if(element){
                (element as HTMLElement).focus();
            }        

        }
        if (text.includes('Other Coverage Group is invalid')) {
            this.linktoErrorControl.isOTHCVRGGRPError = true;
            this.scroller.scrollToAnchor("txtOTHCVRGGRP");
            // optionally focus after scrolling:
            const element = document.getElementById("txtOTHCVRGGRP");
            if(element){
                (element as HTMLElement).focus();
            }        

        }
        if (text.includes('Long Term Care Facility is required')) {
            this.linktoErrorControl.isRBLLONGTERMError = true;
            this.scroller.scrollToAnchor("txtRBLLONGTERM");
            // optionally focus after scrolling:
            const element = document.getElementById("txtRBLLONGTERM");
            if(element){
                (element as HTMLElement).focus();
            }        

        }
        if (text.includes('Zip is required')) {
            this.linktoErrorControl.isZipERMError = true;
            this.scroller.scrollToAnchor("txtZip");
            // optionally focus after scrolling:
            const element = document.getElementById("txtZip");
            if(element){
                (element as HTMLElement).focus();
            }        

        }
        if (text.includes('Please select Account type')) {
            this.linktoErrorControl.isEFTTYPEError = true;
            this.scroller.scrollToAnchor("txtEFTTYPE");
            // optionally focus after scrolling:
            const element = document.getElementById("txtEFTTYPE");
            if(element){
                (element as HTMLElement).focus();
            }        

        }
        if (text.includes('Please enter valid Account Name')) {
            this.linktoErrorControl.isACCHOLDERNAMEError = true;
            this.scroller.scrollToAnchor("txtACCHOLDERNAME");
            // optionally focus after scrolling:
            const element = document.getElementById("txtACCHOLDERNAME");
            if(element){
                (element as HTMLElement).focus();
            }        

        }

     
    }

}
